import { Space, Tag } from "antd";

export const lineData = [
  {
    name: "5k",
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: "10k",
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: "15k",
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: "25k",
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "30k",
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: "35k",
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: "40k",
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

export const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    render: (text) => <a>{text}</a>,
  },
  {
    title: "Age",
    dataIndex: "age",
    key: "age",
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
  },
  {
    title: "Tags",
    key: "tags",
    dataIndex: "tags",
    render: (tags) => (
      <>
        {tags.map((tag) => {
          let color = tag.length > 5 ? "geekblue" : "green";
          if (tag === "loser") {
            color = "volcano";
          }
          return (
            <Tag color={color} key={tag}>
              {tag.toUpperCase()}
            </Tag>
          );
        })}
      </>
    ),
  },
  {
    title: "Action",
    key: "action",
    render: (text, record) => (
      <Space size="middle">
        <a>Invite {record.name}</a>
        <a>Delete</a>
      </Space>
    ),
  },
];

export const data = [
  {
    key: "1",
    name: "John Brown",
    age: 32,
    address: "New York No. 1 Lake Park",
    tags: ["nice", "developer"],
  },
  {
    key: "2",
    name: "Jim Green",
    age: 42,
    address: "London No. 1 Lake Park",
    tags: ["loser"],
  },
  {
    key: "3",
    name: "Joe Black",
    age: 32,
    address: "Sidney No. 1 Lake Park",
    tags: ["cool", "teacher"],
  },
];

//   const DATA_COUNT = 7;
// const NUMBER_CFG = {count: DATA_COUNT, min: -100, max: 100};

// const labels = Utils.months({count: 7});
const dataChart = {
  // labels: labels,
  labels: ["January", "February", "March", "April", "May", "June", "July"],
  datasets: [
    {
      label: "Dataset 1",
      data: [65, 59, 80, 81, 56, 55, 40],
      // borderColor: Utils.CHART_COLORS.red,
      // backgroundColor: Utils.transparentize(Utils.CHART_COLORS.red, 0.5),
    },
    {
      label: "Dataset 2",
      data: [28, 48, 40, 19, 86, 27, 90],
      // borderColor: Utils.CHART_COLORS.blue,
      // backgroundColor: Utils.transparentize(Utils.CHART_COLORS.blue, 0.5),
    },
  ],
};

export const CarsList = [
  {
    id: 170538,
    type: 2,
    title: "شيري Arrizo 5 Luxury 2023 ",
    year: "2023",
    is_new: "جديدة",
    car_condition: 1,
    price: {
      price: {
        text: "49,220",
        currency: "ريال",
        color: "#00B658",
        text_in: "السعر لا يشمل الضريبه المضافه",
      },
      none_vat_price: {
        text: "42,800",
        header: "السعر قبل الضريبة",
        currency: "ريال",
        color: "#00b658",
        class: "",
      },
      vat_price: {
        text: "49,220",
        header: "السعر يشمل الضريبة المضافة",
        currency: "ريال",
        color: "#484848",
        class: "",
      },
      price_finance: {
        text: "958",
        currency: "ريال",
        color: "#00B658",
        first_payment: "4,888",
        last_payment: "12,219",
        installment_period: "60",
        text_in: "هذا السعر تقديري ويتضمن التأمين الشامل للسيارة",
      },
    },
    record_posted_date: "قبل1 شهر",
    city: "جدة",
    img_url:
      "https://cdn.syarah.com/online/posts/170538/0x300/orignal-1685109772-286.jpg",
    img_alt_url:
      "https://cdn.syarah.com/online/posts/170538/orignal-1685109772-286.jpg",
    img_big_url:
      "https://cdn.syarah.com/online/posts/170538/0x426/orignal-1685109772-286.jpg",
    img_big_alt_url:
      "https://cdn.syarah.com/online/posts/170538/orignal-1685109772-286.jpg",
    online_service_tag: null,
    best_price_tag: null,
    embed_post_tag: null,
    reserved_tag: null,
    price_saving: "1,025",
    save_money: null,
    save_money_box: null,
    save_money_box_drop: null,
    low_millage: null,
    finance_tag: null,
    params: {
      sol: 1,
    },
    tags: [
      {
        tag_name: "اقل من السوق بـ <b>1,025</b>",
        icone: "https://cdn.syarah.com/syarah/bundles/dddGrn.svg",
        text_color: "#ffffff",
        background_color: "#00b362",
      },
    ],
    make: {
      id: "36",
      name: "شيري",
    },
    model: {
      id: "2217",
      name: "Arrizo 5",
    },
    extension: {
      id: "2101",
      name: "Luxury",
    },
    car_option_ids:
      "4 , 32 , 5 , 48 , 6 , 72 , 2 , 16 , 113 , 15 , 97 , 11 , 91 , 9 , 47 , 12 , 57 , 36 , 51 , 35 , 34 , 40 , 14 , 37 , 19 , 41 , 27 , 18 , 129 , 22 , 117 , 20 , 105 , 2 , 4 , 5 , 6 , 16 , 32 , 48 , 72 , 113 , 9 , 11 , 15 , 47 , 91 , 97 , 12 , 14 , 34 , 35 , 36 , 37 , 40 , 51 , 57 , 18 , 19 , 20 , 22 , 27 , 105 , 117 , 129",
    delivery: {
      hour24: false,
      threeDay: false,
    },
    have_finance: true,
    test: false,
    ranking: 0,
    data_layer: {
      id: 170538,
      name: "Chery Arrizo 5 Luxury 2023 Half Full",
      price: 49220,
      brand: "Chery",
      category: "Syarah",
      variant: "Arrizo 5 2023",
      model: "Arrizo 5",
      year: "2023",
      origin: "Saudi",
      options: "Half Full",
      condition: "New",
      isNew: "1",
      color: "grey",
      interior_color: "",
      fuel: "Gasoline",
      transmission: "CVT",
      cabin: "",
      cylinder: "4",
      mileage: 0,
      drivetrain: "FWD",
      engine_size: "1.5",
      shape: null,
      dimension1: "Chery",
      dimension2: "Arrizo 5",
      dimension3: "2023",
      dimension4: "New",
      dimension5: "Syarah",
      dimension6: "Saudi|Half Full",
      dimension7: "Gasoline|CVT|FWD",
      dimension8: "4|1.5",
      dimension9: "|grey",
      dimension10: 0,
      post_features:
        "مقاعد جلد/تشغيل بصمة/تحكم دريكسون/مثبت سرعة/زجاج كهربائي/مكيف يدوي/فتح الابواب بالريموت/تحكم مقاعد يدوى/ ISOFIX لتثبيت مقاعد الاطفال/بلوتوث/مدخل USB/كاميرا خلفية/منافذ طاقة/شاشة وسائط/راديو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/مساعد الفرامل BA/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/مرايا تحكم كهربائي/كشافات ضباب امامية/جنوط/حساسات خلفية/مصابيح هالوجين/مصابيح ضباب خلفية/أنوار نهارية LED/التحكم بارتفاع الأنوار الأمامية",
    },
    g4_data_layer: {
      post_id: 170538,
      name: "Chery Arrizo 5 Luxury 2023 Half Full",
      post_price: 49220,
      post_make: "Chery",
      post_installment_from: "4888",
      post_installment_to: "12219",
      post_model: "Arrizo 5",
      post_year: "2023",
      post_ext: "Luxury",
      post_origin: "Saudi",
      post_condition: "New",
      post_city: "Jeddah",
      post_exterior_color: "Grey ",
      post_interior_color: "Beige",
      post_fuel: "Gasoline",
      post_transmission: "CVT",
      post_cabin: null,
      discount_tag: "Off",
      post_mileage: null,
      post_drivetrain: "FWD",
      post_engine_size: "1.5",
      post_features:
        "مقاعد جلد/تشغيل بصمة/تحكم دريكسون/مثبت سرعة/زجاج كهربائي/مكيف يدوي/فتح الابواب بالريموت/تحكم مقاعد يدوى/ ISOFIX لتثبيت مقاعد الاطفال/بلوتوث/مدخل USB/كاميرا خلفية/منافذ طاقة/شاشة وسائط/راديو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/مساعد الفرامل BA/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/مرايا تحكم كهربائي/كشافات ضباب امامية/جنوط/حساسات خلفية/مصابيح هالوجين/مصابيح ضباب خلفية/أنوار نهارية LED/التحكم بارتفاع الأنوار الأمامية",
      post_cylinder: "4",
      is_finance: "yes",
      inventory_type: 3,
    },
    campaign: null,
    new_tags: [
      {
        tag_name: "جديدة",
        icon: null,
        text_color: "#4B5A6B",
        background_color: "#F1F6FC",
      },
      {
        tag_name: "اقل من السوق بـ ",
        attr: "1,025",
        att_ext: "ريال",
        icon: "https://cdn.syarah.com/syarah/bundles/dddGrn.svg",
        text_color: "#ffffff",
        background_color: "#00b362",
      },
    ],
    limited_quantity: false,
    isFavorite: false,
    can_test_drive: false,
  },
  {
    id: 170460,
    type: 2,
    title: "شيري Tiggo 2 Pro Luxury 2023 ",
    year: "2023",
    is_new: "جديدة",
    car_condition: 1,
    price: {
      price: {
        text: "49,795",
        currency: "ريال",
        color: "#00B658",
        text_in: "السعر لا يشمل الضريبه المضافه",
      },
      none_vat_price: {
        text: "43,300",
        header: "السعر قبل الضريبة",
        currency: "ريال",
        color: "#00b658",
        class: "",
      },
      vat_price: {
        text: "49,795",
        header: "السعر يشمل الضريبة المضافة",
        currency: "ريال",
        color: "#484848",
        class: "",
      },
      price_finance: {
        text: "969",
        currency: "ريال",
        color: "#00B658",
        first_payment: "4,945",
        last_payment: "12,363",
        installment_period: "60",
        text_in: "هذا السعر تقديري ويتضمن التأمين الشامل للسيارة",
      },
    },
    record_posted_date: "قبل1 شهر",
    city: "الرياض",
    img_url:
      "https://cdn.syarah.com/online/posts/170460/0x300/orignal-1686690227-843.jpg",
    img_alt_url:
      "https://cdn.syarah.com/online/posts/170460/orignal-1686690227-843.jpg",
    img_big_url:
      "https://cdn.syarah.com/online/posts/170460/0x426/orignal-1686690227-843.jpg",
    img_big_alt_url:
      "https://cdn.syarah.com/online/posts/170460/orignal-1686690227-843.jpg",
    online_service_tag: null,
    best_price_tag: null,
    embed_post_tag: null,
    reserved_tag: null,
    price_saving: "3,583",
    save_money: null,
    save_money_box: null,
    save_money_box_drop: null,
    low_millage: null,
    finance_tag: null,
    params: {
      sol: 1,
    },
    tags: [
      {
        tag_name: "اقل من السوق بـ <b>3,583</b>",
        icone: "https://cdn.syarah.com/syarah/bundles/dddGrn.svg",
        text_color: "#ffffff",
        background_color: "#00b362",
      },
    ],
    make: {
      id: "36",
      name: "شيري",
    },
    model: {
      id: "2203",
      name: "Tiggo 2 Pro",
    },
    extension: {
      id: "2029",
      name: "Luxury",
    },
    car_option_ids:
      "113 , 48 , 133 , 4 , 5 , 6 , 16 , 33 , 67 , 72 , 115 , 9 , 11 , 15 , 47 , 91 , 97 , 107 , 57 , 12 , 14 , 34 , 35 , 36 , 40 , 105 , 117 , 129 , 18 , 19 , 20 , 22 , 23 , 28 , 43 , 65 , 93 , 4 , 5 , 6 , 16 , 33 , 48 , 67 , 72 , 113 , 115 , 133 , 9 , 11 , 15 , 47 , 91 , 97 , 12 , 14 , 34 , 35 , 36 , 40 , 57 , 18 , 19 , 20 , 22 , 23 , 28 , 43 , 65 , 93 , 105 , 117 , 129",
    delivery: {
      hour24: false,
      threeDay: false,
    },
    have_finance: true,
    test: false,
    ranking: 0,
    data_layer: {
      id: 170460,
      name: "Chery Tiggo 2 Pro  2023 Full",
      price: 49795,
      brand: "Chery",
      category: "Syarah",
      variant: "Tiggo 2 Pro 2023",
      model: "Tiggo 2 Pro",
      year: "2023",
      origin: "Saudi",
      options: "Full",
      condition: "New",
      isNew: "1",
      color: "grey",
      interior_color: "black",
      fuel: "Gasoline",
      transmission: "CVT",
      cabin: "",
      cylinder: "4",
      mileage: 0,
      drivetrain: "",
      engine_size: "1.5",
      shape: null,
      dimension1: "Chery",
      dimension2: "Tiggo 2 Pro",
      dimension3: "2023",
      dimension4: "New",
      dimension5: "Syarah",
      dimension6: "Saudi|Full",
      dimension7: "Gasoline|CVT|",
      dimension8: "4|1.5",
      dimension9: "|grey",
      dimension10: 0,
      post_features:
        "تشغيل بصمة/تحكم دريكسون/مثبت سرعة/زجاج كهربائي/مكيف أوتوماتيك/فتح الابواب بالريموت/أوامر صوتية/تحكم مقاعد يدوى/ ISOFIX لتثبيت مقاعد الاطفال/مقاعد خلفية قابلة للطي/مقاعد قماش وجلد/بلوتوث/مدخل USB/كاميرا خلفية/منافذ طاقة/شاشة وسائط/راديو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/أحزمة أمان/نظام التحكم بالإنزلاق (TRC)/مرايا تحكم كهربائي/كشافات ضباب امامية/جنوط/حساسات خلفية/فتحة سقف/مصابيح ليد/اشارات بالمرايا/جناح خلفى/دخول ذكي/مصابيح ضباب خلفية/أنوار نهارية LED/التحكم بارتفاع الأنوار الأمامية",
    },
    g4_data_layer: {
      post_id: 170460,
      name: "Chery Tiggo 2 Pro  2023 Full",
      post_price: 49795,
      post_make: "Chery",
      post_installment_from: "4945",
      post_installment_to: "12363",
      post_model: "Tiggo 2 Pro",
      post_year: "2023",
      post_ext: "",
      post_origin: "Saudi",
      post_condition: "New",
      post_city: "Riyadh",
      post_exterior_color: "Grey ",
      post_interior_color: "Black",
      post_fuel: "Gasoline",
      post_transmission: "CVT",
      post_cabin: null,
      discount_tag: "Off",
      post_mileage: null,
      post_drivetrain: null,
      post_engine_size: "1.5",
      post_features:
        "تشغيل بصمة/تحكم دريكسون/مثبت سرعة/زجاج كهربائي/مكيف أوتوماتيك/فتح الابواب بالريموت/أوامر صوتية/تحكم مقاعد يدوى/ ISOFIX لتثبيت مقاعد الاطفال/مقاعد خلفية قابلة للطي/مقاعد قماش وجلد/بلوتوث/مدخل USB/كاميرا خلفية/منافذ طاقة/شاشة وسائط/راديو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/أحزمة أمان/نظام التحكم بالإنزلاق (TRC)/مرايا تحكم كهربائي/كشافات ضباب امامية/جنوط/حساسات خلفية/فتحة سقف/مصابيح ليد/اشارات بالمرايا/جناح خلفى/دخول ذكي/مصابيح ضباب خلفية/أنوار نهارية LED/التحكم بارتفاع الأنوار الأمامية",
      post_cylinder: "4",
      is_finance: "yes",
      inventory_type: 3,
    },
    campaign: null,
    new_tags: [
      {
        tag_name: "جديدة",
        icon: null,
        text_color: "#4B5A6B",
        background_color: "#F1F6FC",
      },
      {
        tag_name: "اقل من السوق بـ ",
        attr: "3,583",
        att_ext: "ريال",
        icon: "https://cdn.syarah.com/syarah/bundles/dddGrn.svg",
        text_color: "#ffffff",
        background_color: "#00b362",
      },
    ],
    limited_quantity: false,
    isFavorite: false,
    can_test_drive: false,
  },
  {
    id: 132371,
    type: 2,
    title: "شيري Tiggo 2 Pro Luxury 2023 ",
    year: "2023",
    is_new: "جديدة",
    car_condition: 1,
    price: {
      price: {
        text: "51,750",
        currency: "ريال",
        color: "#00B658",
        text_in: "السعر لا يشمل الضريبه المضافه",
      },
      none_vat_price: {
        text: "45,000",
        header: "السعر قبل الضريبة",
        currency: "ريال",
        color: "#00b658",
        class: "",
      },
      vat_price: {
        text: "51,750",
        header: "السعر يشمل الضريبة المضافة",
        currency: "ريال",
        color: "#484848",
        class: "",
      },
      price_finance: {
        text: "1,014",
        currency: "ريال",
        color: "#00B658",
        first_payment: "5,175",
        last_payment: "12,938",
        installment_period: "60",
        text_in: "هذا السعر تقديري ويتضمن التأمين الشامل للسيارة",
      },
    },
    record_posted_date: "قبل1 سنة",
    city: "القريات",
    img_url:
      "https://cdn.syarah.com/online/posts/132371/0x300/orignal-1672917264-586_cut.webp",
    img_alt_url:
      "https://cdn.syarah.com/online/posts/132371/orignal-1672917264-586_cut.webp",
    img_big_url:
      "https://cdn.syarah.com/online/posts/132371/0x426/orignal-1672917264-586_cut.webp",
    img_big_alt_url:
      "https://cdn.syarah.com/online/posts/132371/orignal-1672917264-586_cut.webp",
    online_service_tag: null,
    best_price_tag: null,
    embed_post_tag: null,
    reserved_tag: null,
    price_saving: "13,685",
    save_money: null,
    save_money_box: null,
    save_money_box_drop: null,
    low_millage: null,
    finance_tag: null,
    params: {
      sol: 1,
    },
    tags: [
      {
        tag_name: "اقل من السوق بـ <b>13,685</b>",
        icone: "https://cdn.syarah.com/syarah/bundles/dddGrn.svg",
        text_color: "#ffffff",
        background_color: "#00b362",
      },
    ],
    make: {
      id: "36",
      name: "شيري",
    },
    model: {
      id: "2203",
      name: "Tiggo 2 Pro",
    },
    extension: {
      id: "2029",
      name: "Luxury",
    },
    car_option_ids:
      "5 , 6 , 16 , 32 , 48 , 67 , 72 , 113 , 115 , 9 , 11 , 15 , 47 , 91 , 97 , 107 , 109 , 12 , 14 , 34 , 35 , 36 , 37 , 40 , 51 , 57 , 18 , 19 , 20 , 22 , 23 , 28 , 41 , 43 , 65 , 105 , 117 , 129 , 4 , 133 , 38 , 93",
    delivery: {
      hour24: false,
      threeDay: false,
    },
    have_finance: true,
    test: false,
    ranking: 0,
    data_layer: {
      id: 132371,
      name: "Chery Tiggo 2 Pro  2023 Full",
      price: 51750,
      brand: "Chery",
      category: "Syarah",
      variant: "Tiggo 2 Pro 2023",
      model: "Tiggo 2 Pro",
      year: "2023",
      origin: "Saudi",
      options: "Full",
      condition: "New",
      isNew: "1",
      color: "selver",
      interior_color: "black",
      fuel: "Gasoline",
      transmission: "CVT",
      cabin: "",
      cylinder: "4",
      mileage: 0,
      drivetrain: "FWD",
      engine_size: "1.5",
      shape: null,
      dimension1: "Chery",
      dimension2: "Tiggo 2 Pro",
      dimension3: "2023",
      dimension4: "New",
      dimension5: "Syarah",
      dimension6: "Saudi|Full",
      dimension7: "Gasoline|CVT|FWD",
      dimension8: "4|1.5",
      dimension9: "|selver",
      dimension10: 0,
      post_features:
        "تحكم دريكسون/مثبت سرعة/زجاج كهربائي/مكيف يدوي/فتح الابواب بالريموت/أوامر صوتية/تحكم مقاعد يدوى/ ISOFIX لتثبيت مقاعد الاطفال/مقاعد خلفية قابلة للطي/بلوتوث/مدخل USB/كاميرا خلفية/منافذ طاقة/شاشة وسائط/راديو/أبل كار بلاى/أندرويد أوتو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/مساعد الفرامل BA/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/مرايا تحكم كهربائي/كشافات ضباب امامية/جنوط/حساسات خلفية/فتحة سقف/مصابيح ليد/مزيل ضباب/اشارات بالمرايا/جناح خلفى/مصابيح ضباب خلفية/أنوار نهارية LED/التحكم بارتفاع الأنوار الأمامية/تشغيل بصمة/مقاعد قماش وجلد/المساعدة على صعود المرتفعات HAC/دخول ذكي",
    },
    g4_data_layer: {
      post_id: 132371,
      name: "Chery Tiggo 2 Pro  2023 Full",
      post_price: 51750,
      post_make: "Chery",
      post_installment_from: "5175",
      post_installment_to: "12938",
      post_model: "Tiggo 2 Pro",
      post_year: "2023",
      post_ext: "",
      post_origin: "Saudi",
      post_condition: "New",
      post_city: "Al Qurayyat",
      post_exterior_color: "Silver",
      post_interior_color: "Black",
      post_fuel: "Gasoline",
      post_transmission: "CVT",
      post_cabin: null,
      discount_tag: "Off",
      post_mileage: null,
      post_drivetrain: "FWD",
      post_engine_size: "1.5",
      post_features:
        "تحكم دريكسون/مثبت سرعة/زجاج كهربائي/مكيف يدوي/فتح الابواب بالريموت/أوامر صوتية/تحكم مقاعد يدوى/ ISOFIX لتثبيت مقاعد الاطفال/مقاعد خلفية قابلة للطي/بلوتوث/مدخل USB/كاميرا خلفية/منافذ طاقة/شاشة وسائط/راديو/أبل كار بلاى/أندرويد أوتو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/مساعد الفرامل BA/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/مرايا تحكم كهربائي/كشافات ضباب امامية/جنوط/حساسات خلفية/فتحة سقف/مصابيح ليد/مزيل ضباب/اشارات بالمرايا/جناح خلفى/مصابيح ضباب خلفية/أنوار نهارية LED/التحكم بارتفاع الأنوار الأمامية/تشغيل بصمة/مقاعد قماش وجلد/المساعدة على صعود المرتفعات HAC/دخول ذكي",
      post_cylinder: "4",
      is_finance: "yes",
      inventory_type: 3,
    },
    campaign: null,
    new_tags: [
      {
        tag_name: "جديدة",
        icon: null,
        text_color: "#4B5A6B",
        background_color: "#F1F6FC",
      },
      {
        tag_name: "اقل من السوق بـ ",
        attr: "13,685",
        att_ext: "ريال",
        icon: "https://cdn.syarah.com/syarah/bundles/dddGrn.svg",
        text_color: "#ffffff",
        background_color: "#00b362",
      },
    ],
    limited_quantity: false,
    isFavorite: false,
    can_test_drive: false,
  },
  {
    id: 172937,
    type: 2,
    title: "شيري Arrizo 6 Comfort 2023 ",
    year: "2023",
    is_new: "جديدة",
    car_condition: 1,
    price: {
      price: {
        text: "52,325",
        currency: "ريال",
        color: "#00B658",
        text_in: "السعر لا يشمل الضريبه المضافه",
      },
      none_vat_price: {
        text: "45,500",
        header: "السعر قبل الضريبة",
        currency: "ريال",
        color: "#00b658",
        class: "",
      },
      vat_price: {
        text: "52,325",
        header: "السعر يشمل الضريبة المضافة",
        currency: "ريال",
        color: "#484848",
        class: "",
      },
      price_finance: {
        text: "1,019",
        currency: "ريال",
        color: "#00B658",
        first_payment: "5,200",
        last_payment: "13,000",
        installment_period: "60",
        text_in: "هذا السعر تقديري ويتضمن التأمين الشامل للسيارة",
      },
    },
    record_posted_date: "قبل1 اسبوع",
    city: "الرياض",
    img_url:
      "https://cdn.syarah.com/online/posts/172937/0x300/orignal-1670252837-547.jpg",
    img_alt_url:
      "https://cdn.syarah.com/online/posts/172937/orignal-1670252837-547.jpg",
    img_big_url:
      "https://cdn.syarah.com/online/posts/172937/0x426/orignal-1670252837-547.jpg",
    img_big_alt_url:
      "https://cdn.syarah.com/online/posts/172937/orignal-1670252837-547.jpg",
    online_service_tag: null,
    best_price_tag: null,
    embed_post_tag: null,
    reserved_tag: null,
    price_saving: "6,000",
    save_money: null,
    save_money_box: null,
    save_money_box_drop: null,
    low_millage: null,
    finance_tag: null,
    params: {
      sol: 1,
    },
    tags: [
      {
        tag_name: "اقل من السوق بـ <b>6,000</b>",
        icone: "https://cdn.syarah.com/syarah/bundles/dddGrn.svg",
        text_color: "#ffffff",
        background_color: "#00b362",
      },
    ],
    make: {
      id: "36",
      name: "شيري",
    },
    model: {
      id: "2219",
      name: "Arrizo 6",
    },
    extension: {
      id: "2072",
      name: "Comfort",
    },
    car_option_ids:
      "72 , 33 , 113 , 133 , 3 , 4 , 5 , 6 , 16 , 48 , 58 , 73 , 9 , 11 , 15 , 47 , 91 , 97 , 71 , 12 , 14 , 34 , 35 , 36 , 37 , 40 , 51 , 57 , 117 , 129 , 18 , 19 , 20 , 22 , 27 , 28 , 41 , 43 , 93 , 105 , 3 , 4 , 5 , 6 , 16 , 33 , 48 , 72 , 133 , 9 , 11 , 15 , 47 , 91 , 97 , 12 , 14 , 34 , 35 , 36 , 37 , 40 , 51 , 57 , 71 , 18 , 20 , 22 , 27 , 28 , 43 , 93 , 105 , 117 , 129",
    delivery: {
      hour24: false,
      threeDay: false,
    },
    have_finance: true,
    test: false,
    ranking: 0,
    data_layer: {
      id: 172937,
      name: "Chery Arrizo 6 Comfort 2023 Half Full",
      price: 52325,
      brand: "Chery",
      category: "Syarah",
      variant: "Arrizo 6 2023",
      model: "Arrizo 6",
      year: "2023",
      origin: "Saudi",
      options: "Half Full",
      condition: "New",
      isNew: "1",
      color: "white",
      interior_color: "black",
      fuel: "Gasoline",
      transmission: "CVT",
      cabin: "",
      cylinder: "4",
      mileage: 0,
      drivetrain: "FWD",
      engine_size: "1.5",
      shape: null,
      dimension1: "Chery",
      dimension2: "Arrizo 6",
      dimension3: "2023",
      dimension4: "New",
      dimension5: "Syarah",
      dimension6: "Saudi|Half Full",
      dimension7: "Gasoline|CVT|FWD",
      dimension8: "4|1.5",
      dimension9: "|white",
      dimension10: 0,
      post_features:
        "فتحات تكييف خلفية/تشغيل بصمة/تحكم دريكسون/مثبت سرعة/زجاج كهربائي/مكيف أوتوماتيك/فتح الابواب بالريموت/تحكم مقاعد يدوى/مقاعد قماش وجلد/بلوتوث/مدخل USB/كاميرا خلفية/منافذ طاقة/شاشة وسائط/راديو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/مساعد الفرامل BA/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/فرامل يد الكترونى/مرايا تحكم كهربائي/جنوط/حساسات خلفية/مصابيح هالوجين/مصابيح ليد/اشارات بالمرايا/دخول ذكي/مصابيح ضباب خلفية/أنوار نهارية LED/التحكم بارتفاع الأنوار الأمامية",
    },
    g4_data_layer: {
      post_id: 172937,
      name: "Chery Arrizo 6 Comfort 2023 Half Full",
      post_price: 52325,
      post_make: "Chery",
      post_installment_from: "5200",
      post_installment_to: "13000",
      post_model: "Arrizo 6",
      post_year: "2023",
      post_ext: "Comfort",
      post_origin: "Saudi",
      post_condition: "New",
      post_city: "Riyadh",
      post_exterior_color: "White",
      post_interior_color: "Black",
      post_fuel: "Gasoline",
      post_transmission: "CVT",
      post_cabin: null,
      discount_tag: "Off",
      post_mileage: null,
      post_drivetrain: "FWD",
      post_engine_size: "1.5",
      post_features:
        "فتحات تكييف خلفية/تشغيل بصمة/تحكم دريكسون/مثبت سرعة/زجاج كهربائي/مكيف أوتوماتيك/فتح الابواب بالريموت/تحكم مقاعد يدوى/مقاعد قماش وجلد/بلوتوث/مدخل USB/كاميرا خلفية/منافذ طاقة/شاشة وسائط/راديو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/مساعد الفرامل BA/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/فرامل يد الكترونى/مرايا تحكم كهربائي/جنوط/حساسات خلفية/مصابيح هالوجين/مصابيح ليد/اشارات بالمرايا/دخول ذكي/مصابيح ضباب خلفية/أنوار نهارية LED/التحكم بارتفاع الأنوار الأمامية",
      post_cylinder: "4",
      is_finance: "yes",
      inventory_type: 3,
    },
    campaign: null,
    new_tags: [
      {
        tag_name: "جديدة",
        icon: null,
        text_color: "#4B5A6B",
        background_color: "#F1F6FC",
      },
      {
        tag_name: "اقل من السوق بـ ",
        attr: "6,000",
        att_ext: "ريال",
        icon: "https://cdn.syarah.com/syarah/bundles/dddGrn.svg",
        text_color: "#ffffff",
        background_color: "#00b362",
      },
    ],
    limited_quantity: false,
    isFavorite: false,
    can_test_drive: false,
  },
  {
    id: 170287,
    type: 2,
    title: "شيري Tiggo 2 Pro Luxury 2023 ",
    year: "2023",
    is_new: "جديدة",
    car_condition: 1,
    price: {
      price: {
        text: "52,670",
        currency: "ريال",
        color: "#00B658",
        text_in: "السعر لا يشمل الضريبه المضافه",
      },
      none_vat_price: {
        text: "45,800",
        header: "السعر قبل الضريبة",
        currency: "ريال",
        color: "#00b658",
        class: "",
      },
      vat_price: {
        text: "52,670",
        header: "السعر يشمل الضريبة المضافة",
        currency: "ريال",
        color: "#484848",
        class: "",
      },
      price_finance: {
        text: "1,025",
        currency: "ريال",
        color: "#00B658",
        first_payment: "5,230",
        last_payment: "13,075",
        installment_period: "60",
        text_in: "هذا السعر تقديري ويتضمن التأمين الشامل للسيارة",
      },
    },
    record_posted_date: "قبل1 شهر",
    city: "جدة",
    img_url:
      "https://cdn.syarah.com/online/posts/170287/0x300/orignal-1684518419-423.jpg",
    img_alt_url:
      "https://cdn.syarah.com/online/posts/170287/orignal-1684518419-423.jpg",
    img_big_url:
      "https://cdn.syarah.com/online/posts/170287/0x426/orignal-1684518419-423.jpg",
    img_big_alt_url:
      "https://cdn.syarah.com/online/posts/170287/orignal-1684518419-423.jpg",
    online_service_tag: null,
    best_price_tag: null,
    embed_post_tag: null,
    reserved_tag: null,
    price_saving: "8,236",
    save_money: null,
    save_money_box: null,
    save_money_box_drop: null,
    low_millage: null,
    finance_tag: null,
    params: {
      sol: 1,
    },
    tags: [
      {
        tag_name: "اقل من السوق بـ <b>8,236</b>",
        icone: "https://cdn.syarah.com/syarah/bundles/dddGrn.svg",
        text_color: "#ffffff",
        background_color: "#00b362",
      },
    ],
    make: {
      id: "36",
      name: "شيري",
    },
    model: {
      id: "2203",
      name: "Tiggo 2 Pro",
    },
    extension: {
      id: "2029",
      name: "Luxury",
    },
    car_option_ids:
      "5 , 48 , 115 , 6 , 67 , 16 , 72 , 4 , 33 , 133 , 113 , 15 , 107 , 97 , 11 , 91 , 9 , 47 , 109 , 12 , 51 , 36 , 40 , 35 , 34 , 38 , 14 , 57 , 37 , 19 , 93 , 28 , 129 , 23 , 18 , 65 , 117 , 22 , 43 , 105 , 20 , 41 , 4 , 5 , 6 , 16 , 33 , 48 , 67 , 72 , 113 , 115 , 133 , 9 , 11 , 15 , 47 , 91 , 97 , 107 , 109 , 12 , 14 , 34 , 35 , 36 , 37 , 38 , 40 , 51 , 57 , 18 , 19 , 20 , 22 , 23 , 28 , 41 , 43 , 65 , 93 , 105 , 117 , 129",
    delivery: {
      hour24: false,
      threeDay: false,
    },
    have_finance: true,
    test: false,
    ranking: 0,
    data_layer: {
      id: 170287,
      name: "Chery Tiggo 2 Pro  2023 Full",
      price: 52670,
      brand: "Chery",
      category: "Syarah",
      variant: "Tiggo 2 Pro 2023",
      model: "Tiggo 2 Pro",
      year: "2023",
      origin: "Saudi",
      options: "Full",
      condition: "New",
      isNew: "1",
      color: "grey",
      interior_color: "black",
      fuel: "Gasoline",
      transmission: "CVT",
      cabin: "",
      cylinder: "4",
      mileage: 0,
      drivetrain: "FWD",
      engine_size: "1.5",
      shape: null,
      dimension1: "Chery",
      dimension2: "Tiggo 2 Pro",
      dimension3: "2023",
      dimension4: "New",
      dimension5: "Syarah",
      dimension6: "Saudi|Full",
      dimension7: "Gasoline|CVT|FWD",
      dimension8: "4|1.5",
      dimension9: "|grey",
      dimension10: 0,
      post_features:
        "تشغيل بصمة/تحكم دريكسون/مثبت سرعة/زجاج كهربائي/مكيف أوتوماتيك/فتح الابواب بالريموت/أوامر صوتية/تحكم مقاعد يدوى/ ISOFIX لتثبيت مقاعد الاطفال/مقاعد خلفية قابلة للطي/مقاعد قماش وجلد/بلوتوث/مدخل USB/كاميرا خلفية/منافذ طاقة/شاشة وسائط/راديو/أبل كار بلاى/أندرويد أوتو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/مساعد الفرامل BA/المساعدة على صعود المرتفعات HAC/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/مرايا تحكم كهربائي/كشافات ضباب امامية/جنوط/حساسات خلفية/فتحة سقف/مصابيح ليد/مزيل ضباب/اشارات بالمرايا/جناح خلفى/دخول ذكي/مصابيح ضباب خلفية/أنوار نهارية LED/التحكم بارتفاع الأنوار الأمامية",
    },
    g4_data_layer: {
      post_id: 170287,
      name: "Chery Tiggo 2 Pro  2023 Full",
      post_price: 52670,
      post_make: "Chery",
      post_installment_from: "5230",
      post_installment_to: "13075",
      post_model: "Tiggo 2 Pro",
      post_year: "2023",
      post_ext: "",
      post_origin: "Saudi",
      post_condition: "New",
      post_city: "Jeddah",
      post_exterior_color: "Grey ",
      post_interior_color: "Black",
      post_fuel: "Gasoline",
      post_transmission: "CVT",
      post_cabin: null,
      discount_tag: "Off",
      post_mileage: null,
      post_drivetrain: "FWD",
      post_engine_size: "1.5",
      post_features:
        "تشغيل بصمة/تحكم دريكسون/مثبت سرعة/زجاج كهربائي/مكيف أوتوماتيك/فتح الابواب بالريموت/أوامر صوتية/تحكم مقاعد يدوى/ ISOFIX لتثبيت مقاعد الاطفال/مقاعد خلفية قابلة للطي/مقاعد قماش وجلد/بلوتوث/مدخل USB/كاميرا خلفية/منافذ طاقة/شاشة وسائط/راديو/أبل كار بلاى/أندرويد أوتو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/مساعد الفرامل BA/المساعدة على صعود المرتفعات HAC/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/مرايا تحكم كهربائي/كشافات ضباب امامية/جنوط/حساسات خلفية/فتحة سقف/مصابيح ليد/مزيل ضباب/اشارات بالمرايا/جناح خلفى/دخول ذكي/مصابيح ضباب خلفية/أنوار نهارية LED/التحكم بارتفاع الأنوار الأمامية",
      post_cylinder: "4",
      is_finance: "yes",
      inventory_type: 3,
    },
    campaign: null,
    new_tags: [
      {
        tag_name: "جديدة",
        icon: null,
        text_color: "#4B5A6B",
        background_color: "#F1F6FC",
      },
      {
        tag_name: "اقل من السوق بـ ",
        attr: "8,236",
        att_ext: "ريال",
        icon: "https://cdn.syarah.com/syarah/bundles/dddGrn.svg",
        text_color: "#ffffff",
        background_color: "#00b362",
      },
    ],
    limited_quantity: false,
    isFavorite: false,
    can_test_drive: false,
  },
  {
    id: 136432,
    type: 2,
    title: "شيري Tiggo 2 Luxury 2023 ",
    year: "2023",
    is_new: "جديدة",
    car_condition: 1,
    price: {
      price: {
        text: "52,785",
        currency: "ريال",
        color: "#00B658",
        text_in: "السعر لا يشمل الضريبه المضافه",
      },
      none_vat_price: {
        text: "45,900",
        header: "السعر قبل الضريبة",
        currency: "ريال",
        color: "#00b658",
        class: "",
      },
      vat_price: {
        text: "52,785",
        header: "السعر يشمل الضريبة المضافة",
        currency: "ريال",
        color: "#484848",
        class: "",
      },
      price_finance: {
        text: "1,034",
        currency: "ريال",
        color: "#00B658",
        first_payment: "5,279",
        last_payment: "13,197",
        installment_period: "60",
        text_in: "هذا السعر تقديري ويتضمن التأمين الشامل للسيارة",
      },
    },
    record_posted_date: "قبل11 شهر",
    city: "القريات",
    img_url:
      "https://cdn.syarah.com/online/posts/136432/0x300/orignal-1652724552-41_cut.jpg",
    img_alt_url:
      "https://cdn.syarah.com/online/posts/136432/orignal-1652724552-41_cut.jpg",
    img_big_url:
      "https://cdn.syarah.com/online/posts/136432/0x426/orignal-1652724552-41_cut.jpg",
    img_big_alt_url:
      "https://cdn.syarah.com/online/posts/136432/orignal-1652724552-41_cut.jpg",
    online_service_tag: null,
    best_price_tag: null,
    embed_post_tag: null,
    reserved_tag: null,
    price_saving: null,
    save_money: null,
    save_money_box: null,
    save_money_box_drop: null,
    low_millage: null,
    finance_tag: null,
    params: {
      sol: 1,
    },
    tags: [],
    make: {
      id: "36",
      name: "شيري",
    },
    model: {
      id: "2200",
      name: "Tiggo 2",
    },
    extension: {
      id: "2017",
      name: "Luxury",
    },
    car_option_ids:
      "5 , 6 , 16 , 26 , 32 , 72 , 113 , 115 , 133 , 9 , 11 , 15 , 47 , 91 , 97 , 109 , 12 , 14 , 34 , 35 , 36 , 40 , 51 , 57 , 18 , 19 , 20 , 22 , 41 , 43 , 65 , 105 , 117 , 129 , 38 , 48 , 37 , 28",
    delivery: {
      hour24: false,
      threeDay: false,
    },
    have_finance: true,
    test: false,
    ranking: 0,
    data_layer: {
      id: 136432,
      name: "Chery Tiggo 2 Luxury 2023 Full",
      price: 52785,
      brand: "Chery",
      category: "Syarah",
      variant: "Tiggo 2 2023",
      model: "Tiggo 2",
      year: "2023",
      origin: "Saudi",
      options: "Full",
      condition: "New",
      isNew: "1",
      color: "selver",
      interior_color: "black",
      fuel: "Gasoline",
      transmission: "CVT",
      cabin: "",
      cylinder: "4",
      mileage: 0,
      drivetrain: "FWD",
      engine_size: "1.5",
      shape: null,
      dimension1: "Chery",
      dimension2: "Tiggo 2",
      dimension3: "2023",
      dimension4: "New",
      dimension5: "Syarah",
      dimension6: "Saudi|Full",
      dimension7: "Gasoline|CVT|FWD",
      dimension8: "4|1.5",
      dimension9: "|selver",
      dimension10: 0,
      post_features:
        "تحكم دريكسون/مثبت سرعة/زجاج كهربائي/تشغيل مفتاح/مكيف يدوي/تحكم مقاعد يدوى/ ISOFIX لتثبيت مقاعد الاطفال/مقاعد خلفية قابلة للطي/مقاعد قماش وجلد/بلوتوث/مدخل USB/كاميرا خلفية/منافذ طاقة/شاشة وسائط/راديو/أندرويد أوتو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/مرايا تحكم كهربائي/كشافات ضباب امامية/جنوط/حساسات خلفية/مزيل ضباب/اشارات بالمرايا/جناح خلفى/مصابيح ضباب خلفية/أنوار نهارية LED/التحكم بارتفاع الأنوار الأمامية/المساعدة على صعود المرتفعات HAC/فتح الابواب بالريموت/مساعد الفرامل BA/مصابيح ليد",
    },
    g4_data_layer: {
      post_id: 136432,
      name: "Chery Tiggo 2 Luxury 2023 Full",
      post_price: 52785,
      post_make: "Chery",
      post_installment_from: "5279",
      post_installment_to: "13197",
      post_model: "Tiggo 2",
      post_year: "2023",
      post_ext: "Luxury",
      post_origin: "Saudi",
      post_condition: "New",
      post_city: "Al Qurayyat",
      post_exterior_color: "Silver",
      post_interior_color: "Black",
      post_fuel: "Gasoline",
      post_transmission: "CVT",
      post_cabin: null,
      discount_tag: "Off",
      post_mileage: null,
      post_drivetrain: "FWD",
      post_engine_size: "1.5",
      post_features:
        "تحكم دريكسون/مثبت سرعة/زجاج كهربائي/تشغيل مفتاح/مكيف يدوي/تحكم مقاعد يدوى/ ISOFIX لتثبيت مقاعد الاطفال/مقاعد خلفية قابلة للطي/مقاعد قماش وجلد/بلوتوث/مدخل USB/كاميرا خلفية/منافذ طاقة/شاشة وسائط/راديو/أندرويد أوتو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/مرايا تحكم كهربائي/كشافات ضباب امامية/جنوط/حساسات خلفية/مزيل ضباب/اشارات بالمرايا/جناح خلفى/مصابيح ضباب خلفية/أنوار نهارية LED/التحكم بارتفاع الأنوار الأمامية/المساعدة على صعود المرتفعات HAC/فتح الابواب بالريموت/مساعد الفرامل BA/مصابيح ليد",
      post_cylinder: "4",
      is_finance: "yes",
      inventory_type: 3,
    },
    campaign: null,
    new_tags: [
      {
        tag_name: "جديدة",
        icon: null,
        text_color: "#4B5A6B",
        background_color: "#F1F6FC",
      },
    ],
    limited_quantity: false,
    isFavorite: false,
    can_test_drive: false,
  },
  {
    id: 134850,
    type: 2,
    title: "شيري Tiggo 2 Pro Luxury 2023 ",
    year: "2023",
    is_new: "جديدة",
    car_condition: 1,
    price: {
      price: {
        text: "52,785",
        currency: "ريال",
        color: "#00B658",
        text_in: "السعر لا يشمل الضريبه المضافه",
      },
      none_vat_price: {
        text: "45,900",
        header: "السعر قبل الضريبة",
        currency: "ريال",
        color: "#00b658",
        class: "",
      },
      vat_price: {
        text: "52,785",
        header: "السعر يشمل الضريبة المضافة",
        currency: "ريال",
        color: "#484848",
        class: "",
      },
      price_finance: {
        text: "1,034",
        currency: "ريال",
        color: "#00B658",
        first_payment: "5,279",
        last_payment: "13,197",
        installment_period: "60",
        text_in: "هذا السعر تقديري ويتضمن التأمين الشامل للسيارة",
      },
    },
    record_posted_date: "قبل11 شهر",
    city: "القريات",
    img_url:
      "https://cdn.syarah.com/online/posts/134850/0x300/orignal-1672915142-60_cut.webp",
    img_alt_url:
      "https://cdn.syarah.com/online/posts/134850/orignal-1672915142-60_cut.webp",
    img_big_url:
      "https://cdn.syarah.com/online/posts/134850/0x426/orignal-1672915142-60_cut.webp",
    img_big_alt_url:
      "https://cdn.syarah.com/online/posts/134850/orignal-1672915142-60_cut.webp",
    online_service_tag: null,
    best_price_tag: null,
    embed_post_tag: null,
    reserved_tag: null,
    price_saving: null,
    save_money: null,
    save_money_box: null,
    save_money_box_drop: null,
    low_millage: null,
    finance_tag: null,
    params: {
      sol: 1,
    },
    tags: [],
    make: {
      id: "36",
      name: "شيري",
    },
    model: {
      id: "2203",
      name: "Tiggo 2 Pro",
    },
    extension: {
      id: "2029",
      name: "Luxury",
    },
    car_option_ids:
      "4 , 5 , 6 , 16 , 48 , 67 , 72 , 113 , 115 , 9 , 11 , 15 , 47 , 91 , 97 , 12 , 14 , 34 , 35 , 36 , 37 , 40 , 51 , 57 , 18 , 19 , 20 , 22 , 23 , 28 , 41 , 43 , 65 , 105 , 117 , 129 , 133 , 107 , 109 , 38 , 93 , 32",
    delivery: {
      hour24: false,
      threeDay: false,
    },
    have_finance: true,
    test: false,
    ranking: 0,
    data_layer: {
      id: 134850,
      name: "Chery Tiggo 2 Pro  2023 Full",
      price: 52785,
      brand: "Chery",
      category: "Syarah",
      variant: "Tiggo 2 Pro 2023",
      model: "Tiggo 2 Pro",
      year: "2023",
      origin: "Saudi",
      options: "Full",
      condition: "New",
      isNew: "1",
      color: "",
      interior_color: "black",
      fuel: "Gasoline",
      transmission: "CVT",
      cabin: "",
      cylinder: "4",
      mileage: 0,
      drivetrain: "FWD",
      engine_size: "1.5",
      shape: null,
      dimension1: "Chery",
      dimension2: "Tiggo 2 Pro",
      dimension3: "2023",
      dimension4: "New",
      dimension5: "Syarah",
      dimension6: "Saudi|Full",
      dimension7: "Gasoline|CVT|FWD",
      dimension8: "4|1.5",
      dimension9: "|",
      dimension10: 0,
      post_features:
        "تشغيل بصمة/تحكم دريكسون/مثبت سرعة/زجاج كهربائي/فتح الابواب بالريموت/أوامر صوتية/تحكم مقاعد يدوى/ ISOFIX لتثبيت مقاعد الاطفال/مقاعد خلفية قابلة للطي/بلوتوث/مدخل USB/كاميرا خلفية/منافذ طاقة/شاشة وسائط/راديو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/مساعد الفرامل BA/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/مرايا تحكم كهربائي/كشافات ضباب امامية/جنوط/حساسات خلفية/فتحة سقف/مصابيح ليد/مزيل ضباب/اشارات بالمرايا/جناح خلفى/مصابيح ضباب خلفية/أنوار نهارية LED/التحكم بارتفاع الأنوار الأمامية/مقاعد قماش وجلد/أبل كار بلاى/أندرويد أوتو/المساعدة على صعود المرتفعات HAC/دخول ذكي/مكيف يدوي",
    },
    g4_data_layer: {
      post_id: 134850,
      name: "Chery Tiggo 2 Pro  2023 Full",
      post_price: 52785,
      post_make: "Chery",
      post_installment_from: "5279",
      post_installment_to: "13197",
      post_model: "Tiggo 2 Pro",
      post_year: "2023",
      post_ext: "",
      post_origin: "Saudi",
      post_condition: "New",
      post_city: "Al Qurayyat",
      post_exterior_color: "Baby blue",
      post_interior_color: "Black",
      post_fuel: "Gasoline",
      post_transmission: "CVT",
      post_cabin: null,
      discount_tag: "Off",
      post_mileage: null,
      post_drivetrain: "FWD",
      post_engine_size: "1.5",
      post_features:
        "تشغيل بصمة/تحكم دريكسون/مثبت سرعة/زجاج كهربائي/فتح الابواب بالريموت/أوامر صوتية/تحكم مقاعد يدوى/ ISOFIX لتثبيت مقاعد الاطفال/مقاعد خلفية قابلة للطي/بلوتوث/مدخل USB/كاميرا خلفية/منافذ طاقة/شاشة وسائط/راديو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/مساعد الفرامل BA/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/مرايا تحكم كهربائي/كشافات ضباب امامية/جنوط/حساسات خلفية/فتحة سقف/مصابيح ليد/مزيل ضباب/اشارات بالمرايا/جناح خلفى/مصابيح ضباب خلفية/أنوار نهارية LED/التحكم بارتفاع الأنوار الأمامية/مقاعد قماش وجلد/أبل كار بلاى/أندرويد أوتو/المساعدة على صعود المرتفعات HAC/دخول ذكي/مكيف يدوي",
      post_cylinder: "4",
      is_finance: "yes",
      inventory_type: 3,
    },
    campaign: null,
    new_tags: [
      {
        tag_name: "جديدة",
        icon: null,
        text_color: "#4B5A6B",
        background_color: "#F1F6FC",
      },
    ],
    limited_quantity: false,
    isFavorite: false,
    can_test_drive: false,
  },
  {
    id: 172819,
    type: 2,
    title: "شيري Tiggo 2 Luxury 2023 ",
    year: "2023",
    is_new: "جديدة",
    car_condition: 1,
    price: {
      price: {
        text: "53,245",
        currency: "ريال",
        color: "#00B658",
        text_in: "السعر لا يشمل الضريبه المضافه",
      },
      none_vat_price: {
        text: "46,300",
        header: "السعر قبل الضريبة",
        currency: "ريال",
        color: "#00b658",
        class: "",
      },
      vat_price: {
        text: "53,245",
        header: "السعر يشمل الضريبة المضافة",
        currency: "ريال",
        color: "#484848",
        class: "",
      },
      price_finance: {
        text: "1,036",
        currency: "ريال",
        color: "#00B658",
        first_payment: "5,290",
        last_payment: "13,225",
        installment_period: "60",
        text_in: "هذا السعر تقديري ويتضمن التأمين الشامل للسيارة",
      },
    },
    record_posted_date: "قبل1 اسبوع",
    city: "الرياض",
    img_url:
      "https://cdn.syarah.com/online/posts/172819/0x300/orignal-1685516955-396.jpg",
    img_alt_url:
      "https://cdn.syarah.com/online/posts/172819/orignal-1685516955-396.jpg",
    img_big_url:
      "https://cdn.syarah.com/online/posts/172819/0x426/orignal-1685516955-396.jpg",
    img_big_alt_url:
      "https://cdn.syarah.com/online/posts/172819/orignal-1685516955-396.jpg",
    online_service_tag: null,
    best_price_tag: null,
    embed_post_tag: null,
    reserved_tag: null,
    price_saving: null,
    save_money: null,
    save_money_box: null,
    save_money_box_drop: null,
    low_millage: null,
    finance_tag: null,
    params: {
      sol: 1,
    },
    tags: [],
    make: {
      id: "36",
      name: "شيري",
    },
    model: {
      id: "2200",
      name: "Tiggo 2",
    },
    extension: {
      id: "2017",
      name: "Luxury",
    },
    car_option_ids:
      "133 , 48 , 5 , 6 , 16 , 26 , 32 , 72 , 115 , 91 , 9 , 11 , 47 , 97 , 12 , 14 , 34 , 35 , 36 , 40 , 51 , 57 , 123 , 129 , 18 , 19 , 20 , 22 , 28 , 43 , 65 , 105 , 117 , 5 , 6 , 16 , 26 , 32 , 48 , 72 , 115 , 133 , 9 , 11 , 47 , 91 , 97 , 12 , 14 , 34 , 35 , 36 , 40 , 51 , 57 , 18 , 19 , 20 , 22 , 28 , 43 , 65 , 105 , 117 , 123 , 129",
    delivery: {
      hour24: false,
      threeDay: false,
    },
    have_finance: true,
    test: false,
    ranking: 0,
    data_layer: {
      id: 172819,
      name: "Chery Tiggo 2 Luxury 2023 Full",
      price: 53245,
      brand: "Chery",
      category: "Syarah",
      variant: "Tiggo 2 2023",
      model: "Tiggo 2",
      year: "2023",
      origin: "Saudi",
      options: "Full",
      condition: "New",
      isNew: "1",
      color: "selver",
      interior_color: "black",
      fuel: "Gasoline",
      transmission: "CVT",
      cabin: "",
      cylinder: "4",
      mileage: 0,
      drivetrain: "FWD",
      engine_size: "1.5",
      shape: null,
      dimension1: "Chery",
      dimension2: "Tiggo 2",
      dimension3: "2023",
      dimension4: "New",
      dimension5: "Syarah",
      dimension6: "Saudi|Full",
      dimension7: "Gasoline|CVT|FWD",
      dimension8: "4|1.5",
      dimension9: "|selver",
      dimension10: 0,
      post_features:
        "تحكم دريكسون/مثبت سرعة/زجاج كهربائي/تشغيل مفتاح/مكيف يدوي/فتح الابواب بالريموت/تحكم مقاعد يدوى/مقاعد خلفية قابلة للطي/مقاعد قماش وجلد/بلوتوث/مدخل USB/منافذ طاقة/شاشة وسائط/راديو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/مرايا تحكم كهربائي/كشافات ضباب امامية/جنوط/حساسات خلفية/مصابيح ليد/اشارات بالمرايا/جناح خلفى/مصابيح ضباب خلفية/أنوار نهارية LED/حنايا عفش/التحكم بارتفاع الأنوار الأمامية",
    },
    g4_data_layer: {
      post_id: 172819,
      name: "Chery Tiggo 2 Luxury 2023 Full",
      post_price: 53245,
      post_make: "Chery",
      post_installment_from: "5290",
      post_installment_to: "13225",
      post_model: "Tiggo 2",
      post_year: "2023",
      post_ext: "Luxury",
      post_origin: "Saudi",
      post_condition: "New",
      post_city: "Riyadh",
      post_exterior_color: "Silver",
      post_interior_color: "Black",
      post_fuel: "Gasoline",
      post_transmission: "CVT",
      post_cabin: null,
      discount_tag: "Off",
      post_mileage: null,
      post_drivetrain: "FWD",
      post_engine_size: "1.5",
      post_features:
        "تحكم دريكسون/مثبت سرعة/زجاج كهربائي/تشغيل مفتاح/مكيف يدوي/فتح الابواب بالريموت/تحكم مقاعد يدوى/مقاعد خلفية قابلة للطي/مقاعد قماش وجلد/بلوتوث/مدخل USB/منافذ طاقة/شاشة وسائط/راديو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/مرايا تحكم كهربائي/كشافات ضباب امامية/جنوط/حساسات خلفية/مصابيح ليد/اشارات بالمرايا/جناح خلفى/مصابيح ضباب خلفية/أنوار نهارية LED/حنايا عفش/التحكم بارتفاع الأنوار الأمامية",
      post_cylinder: "4",
      is_finance: "yes",
      inventory_type: 3,
    },
    campaign: null,
    new_tags: [
      {
        tag_name: "جديدة",
        icon: null,
        text_color: "#4B5A6B",
        background_color: "#F1F6FC",
      },
    ],
    limited_quantity: false,
    isFavorite: false,
    can_test_drive: false,
  },
  {
    id: 172265,
    type: 2,
    title: "شيري Tiggo 2 Luxury 2023 ",
    year: "2023",
    is_new: "جديدة",
    car_condition: 1,
    price: {
      price: {
        text: "53,245",
        currency: "ريال",
        color: "#00B658",
        text_in: "السعر لا يشمل الضريبه المضافه",
      },
      none_vat_price: {
        text: "46,300",
        header: "السعر قبل الضريبة",
        currency: "ريال",
        color: "#00b658",
        class: "",
      },
      vat_price: {
        text: "53,245",
        header: "السعر يشمل الضريبة المضافة",
        currency: "ريال",
        color: "#484848",
        class: "",
      },
      price_finance: {
        text: "1,036",
        currency: "ريال",
        color: "#00B658",
        first_payment: "5,290",
        last_payment: "13,225",
        installment_period: "60",
        text_in: "هذا السعر تقديري ويتضمن التأمين الشامل للسيارة",
      },
    },
    record_posted_date: "قبل2 اسبوع",
    city: "الرياض",
    img_url:
      "https://cdn.syarah.com/online/posts/172265/0x300/orignal-1688557392-17.jpg",
    img_alt_url:
      "https://cdn.syarah.com/online/posts/172265/orignal-1688557392-17.jpg",
    img_big_url:
      "https://cdn.syarah.com/online/posts/172265/0x426/orignal-1688557392-17.jpg",
    img_big_alt_url:
      "https://cdn.syarah.com/online/posts/172265/orignal-1688557392-17.jpg",
    online_service_tag: null,
    best_price_tag: null,
    embed_post_tag: null,
    reserved_tag: null,
    price_saving: "6,902",
    save_money: null,
    save_money_box: null,
    save_money_box_drop: null,
    low_millage: null,
    finance_tag: null,
    params: {
      sol: 1,
    },
    tags: [
      {
        tag_name: "اقل من السوق بـ <b>6,902</b>",
        icone: "https://cdn.syarah.com/syarah/bundles/dddGrn.svg",
        text_color: "#ffffff",
        background_color: "#00b362",
      },
    ],
    make: {
      id: "36",
      name: "شيري",
    },
    model: {
      id: "2200",
      name: "Tiggo 2",
    },
    extension: {
      id: "2017",
      name: "Luxury",
    },
    car_option_ids:
      "133 , 48 , 5 , 6 , 16 , 26 , 32 , 72 , 115 , 91 , 9 , 11 , 47 , 97 , 12 , 14 , 34 , 35 , 36 , 40 , 51 , 57 , 123 , 129 , 18 , 19 , 20 , 22 , 28 , 41 , 43 , 65 , 105 , 117 , 5 , 6 , 16 , 26 , 32 , 48 , 72 , 115 , 133 , 9 , 11 , 47 , 91 , 97 , 12 , 14 , 34 , 35 , 36 , 40 , 51 , 57 , 18 , 19 , 20 , 22 , 28 , 41 , 43 , 65 , 105 , 117 , 123 , 129",
    delivery: {
      hour24: false,
      threeDay: false,
    },
    have_finance: true,
    test: false,
    ranking: 0,
    data_layer: {
      id: 172265,
      name: "Chery Tiggo 2 Luxury 2023 Full",
      price: 53245,
      brand: "Chery",
      category: "Syarah",
      variant: "Tiggo 2 2023",
      model: "Tiggo 2",
      year: "2023",
      origin: "Saudi",
      options: "Full",
      condition: "New",
      isNew: "1",
      color: "white",
      interior_color: "black",
      fuel: "Gasoline",
      transmission: "CVT",
      cabin: "",
      cylinder: "4",
      mileage: 0,
      drivetrain: "FWD",
      engine_size: "1.5",
      shape: null,
      dimension1: "Chery",
      dimension2: "Tiggo 2",
      dimension3: "2023",
      dimension4: "New",
      dimension5: "Syarah",
      dimension6: "Saudi|Full",
      dimension7: "Gasoline|CVT|FWD",
      dimension8: "4|1.5",
      dimension9: "|white",
      dimension10: 0,
      post_features:
        "تحكم دريكسون/مثبت سرعة/زجاج كهربائي/تشغيل مفتاح/مكيف يدوي/فتح الابواب بالريموت/تحكم مقاعد يدوى/مقاعد خلفية قابلة للطي/مقاعد قماش وجلد/بلوتوث/مدخل USB/منافذ طاقة/شاشة وسائط/راديو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/مرايا تحكم كهربائي/كشافات ضباب امامية/جنوط/حساسات خلفية/مصابيح ليد/مزيل ضباب/اشارات بالمرايا/جناح خلفى/مصابيح ضباب خلفية/أنوار نهارية LED/حنايا عفش/التحكم بارتفاع الأنوار الأمامية",
    },
    g4_data_layer: {
      post_id: 172265,
      name: "Chery Tiggo 2 Luxury 2023 Full",
      post_price: 53245,
      post_make: "Chery",
      post_installment_from: "5290",
      post_installment_to: "13225",
      post_model: "Tiggo 2",
      post_year: "2023",
      post_ext: "Luxury",
      post_origin: "Saudi",
      post_condition: "New",
      post_city: "Riyadh",
      post_exterior_color: "White",
      post_interior_color: "Black",
      post_fuel: "Gasoline",
      post_transmission: "CVT",
      post_cabin: null,
      discount_tag: "Off",
      post_mileage: null,
      post_drivetrain: "FWD",
      post_engine_size: "1.5",
      post_features:
        "تحكم دريكسون/مثبت سرعة/زجاج كهربائي/تشغيل مفتاح/مكيف يدوي/فتح الابواب بالريموت/تحكم مقاعد يدوى/مقاعد خلفية قابلة للطي/مقاعد قماش وجلد/بلوتوث/مدخل USB/منافذ طاقة/شاشة وسائط/راديو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/مرايا تحكم كهربائي/كشافات ضباب امامية/جنوط/حساسات خلفية/مصابيح ليد/مزيل ضباب/اشارات بالمرايا/جناح خلفى/مصابيح ضباب خلفية/أنوار نهارية LED/حنايا عفش/التحكم بارتفاع الأنوار الأمامية",
      post_cylinder: "4",
      is_finance: "yes",
      inventory_type: 3,
    },
    campaign: null,
    new_tags: [
      {
        tag_name: "جديدة",
        icon: null,
        text_color: "#4B5A6B",
        background_color: "#F1F6FC",
      },
      {
        tag_name: "اقل من السوق بـ ",
        attr: "6,902",
        att_ext: "ريال",
        icon: "https://cdn.syarah.com/syarah/bundles/dddGrn.svg",
        text_color: "#ffffff",
        background_color: "#00b362",
      },
    ],
    limited_quantity: false,
    isFavorite: false,
    can_test_drive: false,
  },
  {
    id: 172264,
    type: 2,
    title: "شيري Tiggo 2 Luxury 2023 ",
    year: "2023",
    is_new: "جديدة",
    car_condition: 1,
    price: {
      price: {
        text: "53,245",
        currency: "ريال",
        color: "#00B658",
        text_in: "السعر لا يشمل الضريبه المضافه",
      },
      none_vat_price: {
        text: "46,300",
        header: "السعر قبل الضريبة",
        currency: "ريال",
        color: "#00b658",
        class: "",
      },
      vat_price: {
        text: "53,245",
        header: "السعر يشمل الضريبة المضافة",
        currency: "ريال",
        color: "#484848",
        class: "",
      },
      price_finance: {
        text: "1,036",
        currency: "ريال",
        color: "#00B658",
        first_payment: "5,290",
        last_payment: "13,225",
        installment_period: "60",
        text_in: "هذا السعر تقديري ويتضمن التأمين الشامل للسيارة",
      },
    },
    record_posted_date: "قبل2 اسبوع",
    city: "الرياض",
    img_url:
      "https://cdn.syarah.com/online/posts/172264/0x300/orignal-1688557325-443.jpg",
    img_alt_url:
      "https://cdn.syarah.com/online/posts/172264/orignal-1688557325-443.jpg",
    img_big_url:
      "https://cdn.syarah.com/online/posts/172264/0x426/orignal-1688557325-443.jpg",
    img_big_alt_url:
      "https://cdn.syarah.com/online/posts/172264/orignal-1688557325-443.jpg",
    online_service_tag: null,
    best_price_tag: null,
    embed_post_tag: null,
    reserved_tag: null,
    price_saving: null,
    save_money: null,
    save_money_box: null,
    save_money_box_drop: null,
    low_millage: null,
    finance_tag: null,
    params: {
      sol: 1,
    },
    tags: [],
    make: {
      id: "36",
      name: "شيري",
    },
    model: {
      id: "2200",
      name: "Tiggo 2",
    },
    extension: {
      id: "2017",
      name: "Luxury",
    },
    car_option_ids:
      "133 , 48 , 5 , 6 , 16 , 26 , 32 , 72 , 115 , 91 , 9 , 11 , 47 , 97 , 12 , 14 , 34 , 35 , 36 , 40 , 51 , 57 , 123 , 129 , 18 , 19 , 20 , 22 , 28 , 41 , 43 , 65 , 105 , 117 , 5 , 6 , 16 , 26 , 32 , 48 , 72 , 115 , 133 , 9 , 11 , 47 , 91 , 97 , 12 , 14 , 34 , 35 , 36 , 40 , 51 , 57 , 18 , 19 , 20 , 22 , 28 , 41 , 43 , 65 , 105 , 117 , 123 , 129",
    delivery: {
      hour24: false,
      threeDay: false,
    },
    have_finance: true,
    test: false,
    ranking: 0,
    data_layer: {
      id: 172264,
      name: "Chery Tiggo 2 Luxury 2023 Full",
      price: 53245,
      brand: "Chery",
      category: "Syarah",
      variant: "Tiggo 2 2023",
      model: "Tiggo 2",
      year: "2023",
      origin: "Saudi",
      options: "Full",
      condition: "New",
      isNew: "1",
      color: "grey",
      interior_color: "black",
      fuel: "Gasoline",
      transmission: "CVT",
      cabin: "",
      cylinder: "4",
      mileage: 0,
      drivetrain: "FWD",
      engine_size: "1.5",
      shape: null,
      dimension1: "Chery",
      dimension2: "Tiggo 2",
      dimension3: "2023",
      dimension4: "New",
      dimension5: "Syarah",
      dimension6: "Saudi|Full",
      dimension7: "Gasoline|CVT|FWD",
      dimension8: "4|1.5",
      dimension9: "|grey",
      dimension10: 0,
      post_features:
        "تحكم دريكسون/مثبت سرعة/زجاج كهربائي/تشغيل مفتاح/مكيف يدوي/فتح الابواب بالريموت/تحكم مقاعد يدوى/مقاعد خلفية قابلة للطي/مقاعد قماش وجلد/بلوتوث/مدخل USB/منافذ طاقة/شاشة وسائط/راديو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/مرايا تحكم كهربائي/كشافات ضباب امامية/جنوط/حساسات خلفية/مصابيح ليد/مزيل ضباب/اشارات بالمرايا/جناح خلفى/مصابيح ضباب خلفية/أنوار نهارية LED/حنايا عفش/التحكم بارتفاع الأنوار الأمامية",
    },
    g4_data_layer: {
      post_id: 172264,
      name: "Chery Tiggo 2 Luxury 2023 Full",
      post_price: 53245,
      post_make: "Chery",
      post_installment_from: "5290",
      post_installment_to: "13225",
      post_model: "Tiggo 2",
      post_year: "2023",
      post_ext: "Luxury",
      post_origin: "Saudi",
      post_condition: "New",
      post_city: "Riyadh",
      post_exterior_color: "Grey ",
      post_interior_color: "Black",
      post_fuel: "Gasoline",
      post_transmission: "CVT",
      post_cabin: null,
      discount_tag: "Off",
      post_mileage: null,
      post_drivetrain: "FWD",
      post_engine_size: "1.5",
      post_features:
        "تحكم دريكسون/مثبت سرعة/زجاج كهربائي/تشغيل مفتاح/مكيف يدوي/فتح الابواب بالريموت/تحكم مقاعد يدوى/مقاعد خلفية قابلة للطي/مقاعد قماش وجلد/بلوتوث/مدخل USB/منافذ طاقة/شاشة وسائط/راديو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/مرايا تحكم كهربائي/كشافات ضباب امامية/جنوط/حساسات خلفية/مصابيح ليد/مزيل ضباب/اشارات بالمرايا/جناح خلفى/مصابيح ضباب خلفية/أنوار نهارية LED/حنايا عفش/التحكم بارتفاع الأنوار الأمامية",
      post_cylinder: "4",
      is_finance: "yes",
      inventory_type: 3,
    },
    campaign: null,
    new_tags: [
      {
        tag_name: "جديدة",
        icon: null,
        text_color: "#4B5A6B",
        background_color: "#F1F6FC",
      },
    ],
    limited_quantity: false,
    isFavorite: false,
    can_test_drive: false,
  },
  {
    id: 142202,
    type: 2,
    title: "شيري Arrizo 6 Pro Comfort 2023 ",
    year: "2023",
    is_new: "جديدة",
    car_condition: 1,
    price: {
      price: {
        text: "55,200",
        currency: "ريال",
        color: "#00B658",
        text_in: "السعر لا يشمل الضريبه المضافه",
      },
      none_vat_price: {
        text: "48,000",
        header: "السعر قبل الضريبة",
        currency: "ريال",
        color: "#00b658",
        class: "",
      },
      vat_price: {
        text: "55,200",
        header: "السعر يشمل الضريبة المضافة",
        currency: "ريال",
        color: "#484848",
        class: "",
      },
      price_finance: {
        text: "1,081",
        currency: "ريال",
        color: "#00B658",
        first_payment: "5,520",
        last_payment: "13,800",
        installment_period: "60",
        text_in: "هذا السعر تقديري ويتضمن التأمين الشامل للسيارة",
      },
    },
    record_posted_date: "قبل10 شهر",
    city: "القريات",
    img_url:
      "https://cdn.syarah.com/online/posts/142202/0x300/orignal-1679326489-222_cut.webp",
    img_alt_url:
      "https://cdn.syarah.com/online/posts/142202/orignal-1679326489-222_cut.webp",
    img_big_url:
      "https://cdn.syarah.com/online/posts/142202/0x426/orignal-1679326489-222_cut.webp",
    img_big_alt_url:
      "https://cdn.syarah.com/online/posts/142202/orignal-1679326489-222_cut.webp",
    online_service_tag: null,
    best_price_tag: null,
    embed_post_tag: null,
    reserved_tag: null,
    price_saving: "1,702",
    save_money: null,
    save_money_box: null,
    save_money_box_drop: null,
    low_millage: null,
    finance_tag: null,
    params: {
      sol: 1,
    },
    tags: [
      {
        tag_name: "اقل من السوق بـ <b>1,702</b>",
        icone: "https://cdn.syarah.com/syarah/bundles/dddGrn.svg",
        text_color: "#ffffff",
        background_color: "#00b362",
      },
    ],
    make: {
      id: "36",
      name: "شيري",
    },
    model: {
      id: "2226",
      name: "Arrizo 6 Pro",
    },
    extension: {
      id: "2094",
      name: "Comfort",
    },
    car_option_ids:
      "2 , 3 , 4 , 5 , 6 , 16 , 48 , 113 , 9 , 11 , 15 , 47 , 91 , 97 , 12 , 14 , 34 , 35 , 36 , 37 , 40 , 51 , 57 , 71 , 18 , 20 , 22 , 27 , 28 , 43 , 93 , 105 , 117 , 129 , 33 , 58 , 67 , 72 , 73 , 143 , 107 , 109 , 19",
    delivery: {
      hour24: false,
      threeDay: false,
    },
    have_finance: true,
    test: false,
    ranking: 0,
    data_layer: {
      id: 142202,
      name: "Chery Arrizo 6 Pro Comfort 2023 Standard",
      price: 55200,
      brand: "Chery",
      category: "Syarah",
      variant: "Arrizo 6 Pro 2023",
      model: "Arrizo 6 Pro",
      year: "2023",
      origin: "Saudi",
      options: "Standard",
      condition: "New",
      isNew: "1",
      color: "grey",
      interior_color: "black",
      fuel: "Gasoline",
      transmission: "CVT",
      cabin: "",
      cylinder: "4",
      mileage: 0,
      drivetrain: "FWD",
      engine_size: "1.5",
      shape: null,
      dimension1: "Chery",
      dimension2: "Arrizo 6 Pro",
      dimension3: "2023",
      dimension4: "New",
      dimension5: "Syarah",
      dimension6: "Saudi|Standard",
      dimension7: "Gasoline|CVT|FWD",
      dimension8: "4|1.5",
      dimension9: "|grey",
      dimension10: 0,
      post_features:
        "مقاعد جلد/فتحات تكييف خلفية/تشغيل بصمة/تحكم دريكسون/مثبت سرعة/زجاج كهربائي/فتح الابواب بالريموت/ ISOFIX لتثبيت مقاعد الاطفال/بلوتوث/مدخل USB/كاميرا خلفية/منافذ طاقة/شاشة وسائط/راديو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/مساعد الفرامل BA/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/فرامل يد الكترونى/مرايا تحكم كهربائي/جنوط/حساسات خلفية/مصابيح هالوجين/مصابيح ليد/اشارات بالمرايا/دخول ذكي/مصابيح ضباب خلفية/أنوار نهارية LED/التحكم بارتفاع الأنوار الأمامية/مكيف أوتوماتيك/وضعيات للقيادة/أوامر صوتية/تحكم مقاعد يدوى/تشغيل عن بعد/مسند ذراع خلفي/أبل كار بلاى/أندرويد أوتو/كشافات ضباب امامية",
    },
    g4_data_layer: {
      post_id: 142202,
      name: "Chery Arrizo 6 Pro Comfort 2023 Standard",
      post_price: 55200,
      post_make: "Chery",
      post_installment_from: "5520",
      post_installment_to: "13800",
      post_model: "Arrizo 6 Pro",
      post_year: "2023",
      post_ext: "Comfort",
      post_origin: "Saudi",
      post_condition: "New",
      post_city: "Al Qurayyat",
      post_exterior_color: "Grey ",
      post_interior_color: "Black",
      post_fuel: "Gasoline",
      post_transmission: "CVT",
      post_cabin: null,
      discount_tag: "Off",
      post_mileage: null,
      post_drivetrain: "FWD",
      post_engine_size: "1.5",
      post_features:
        "مقاعد جلد/فتحات تكييف خلفية/تشغيل بصمة/تحكم دريكسون/مثبت سرعة/زجاج كهربائي/فتح الابواب بالريموت/ ISOFIX لتثبيت مقاعد الاطفال/بلوتوث/مدخل USB/كاميرا خلفية/منافذ طاقة/شاشة وسائط/راديو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/مساعد الفرامل BA/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/فرامل يد الكترونى/مرايا تحكم كهربائي/جنوط/حساسات خلفية/مصابيح هالوجين/مصابيح ليد/اشارات بالمرايا/دخول ذكي/مصابيح ضباب خلفية/أنوار نهارية LED/التحكم بارتفاع الأنوار الأمامية/مكيف أوتوماتيك/وضعيات للقيادة/أوامر صوتية/تحكم مقاعد يدوى/تشغيل عن بعد/مسند ذراع خلفي/أبل كار بلاى/أندرويد أوتو/كشافات ضباب امامية",
      post_cylinder: "4",
      is_finance: "yes",
      inventory_type: 3,
    },
    campaign: null,
    new_tags: [
      {
        tag_name: "جديدة",
        icon: null,
        text_color: "#4B5A6B",
        background_color: "#F1F6FC",
      },
      {
        tag_name: "اقل من السوق بـ ",
        attr: "1,702",
        att_ext: "ريال",
        icon: "https://cdn.syarah.com/syarah/bundles/dddGrn.svg",
        text_color: "#ffffff",
        background_color: "#00b362",
      },
    ],
    limited_quantity: false,
    isFavorite: false,
    can_test_drive: false,
  },
  {
    id: 137267,
    type: 2,
    title: "شيري Arrizo 6 Pro Comfort 2023 ",
    year: "2023",
    is_new: "جديدة",
    car_condition: 1,
    price: {
      price: {
        text: "55,200",
        currency: "ريال",
        color: "#00B658",
        text_in: "السعر لا يشمل الضريبه المضافه",
      },
      none_vat_price: {
        text: "48,000",
        header: "السعر قبل الضريبة",
        currency: "ريال",
        color: "#00b658",
        class: "",
      },
      vat_price: {
        text: "55,200",
        header: "السعر يشمل الضريبة المضافة",
        currency: "ريال",
        color: "#484848",
        class: "",
      },
      price_finance: {
        text: "1,081",
        currency: "ريال",
        color: "#00B658",
        first_payment: "5,520",
        last_payment: "13,800",
        installment_period: "60",
        text_in: "هذا السعر تقديري ويتضمن التأمين الشامل للسيارة",
      },
    },
    record_posted_date: "قبل11 شهر",
    city: "القريات",
    img_url:
      "https://cdn.syarah.com/online/posts/137267/0x300/orignal-1679326578-296_cut.webp",
    img_alt_url:
      "https://cdn.syarah.com/online/posts/137267/orignal-1679326578-296_cut.webp",
    img_big_url:
      "https://cdn.syarah.com/online/posts/137267/0x426/orignal-1679326578-296_cut.webp",
    img_big_alt_url:
      "https://cdn.syarah.com/online/posts/137267/orignal-1679326578-296_cut.webp",
    online_service_tag: null,
    best_price_tag: null,
    embed_post_tag: null,
    reserved_tag: null,
    price_saving: "1,437",
    save_money: null,
    save_money_box: null,
    save_money_box_drop: null,
    low_millage: null,
    finance_tag: null,
    params: {
      sol: 1,
    },
    tags: [
      {
        tag_name: "اقل من السوق بـ <b>1,437</b>",
        icone: "https://cdn.syarah.com/syarah/bundles/dddGrn.svg",
        text_color: "#ffffff",
        background_color: "#00b362",
      },
    ],
    make: {
      id: "36",
      name: "شيري",
    },
    model: {
      id: "2226",
      name: "Arrizo 6 Pro",
    },
    extension: {
      id: "2094",
      name: "Comfort",
    },
    car_option_ids:
      "2 , 3 , 4 , 5 , 6 , 16 , 48 , 113 , 9 , 11 , 15 , 47 , 91 , 97 , 12 , 14 , 34 , 35 , 36 , 37 , 40 , 51 , 57 , 71 , 18 , 20 , 22 , 27 , 43 , 93 , 105 , 117 , 129 , 33 , 58 , 67 , 72 , 73 , 143 , 107 , 109 , 19 , 28",
    delivery: {
      hour24: false,
      threeDay: false,
    },
    have_finance: true,
    test: false,
    ranking: 0,
    data_layer: {
      id: 137267,
      name: "Chery Arrizo 6 Pro Comfort 2023 Standard",
      price: 55200,
      brand: "Chery",
      category: "Syarah",
      variant: "Arrizo 6 Pro 2023",
      model: "Arrizo 6 Pro",
      year: "2023",
      origin: "Saudi",
      options: "Standard",
      condition: "New",
      isNew: "1",
      color: "white",
      interior_color: "black",
      fuel: "Gasoline",
      transmission: "CVT",
      cabin: "",
      cylinder: "4",
      mileage: 0,
      drivetrain: "FWD",
      engine_size: "1.5",
      shape: null,
      dimension1: "Chery",
      dimension2: "Arrizo 6 Pro",
      dimension3: "2023",
      dimension4: "New",
      dimension5: "Syarah",
      dimension6: "Saudi|Standard",
      dimension7: "Gasoline|CVT|FWD",
      dimension8: "4|1.5",
      dimension9: "|white",
      dimension10: 0,
      post_features:
        "مقاعد جلد/فتحات تكييف خلفية/تشغيل بصمة/تحكم دريكسون/مثبت سرعة/زجاج كهربائي/فتح الابواب بالريموت/ ISOFIX لتثبيت مقاعد الاطفال/بلوتوث/مدخل USB/كاميرا خلفية/منافذ طاقة/شاشة وسائط/راديو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/مساعد الفرامل BA/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/فرامل يد الكترونى/مرايا تحكم كهربائي/جنوط/حساسات خلفية/مصابيح هالوجين/اشارات بالمرايا/دخول ذكي/مصابيح ضباب خلفية/أنوار نهارية LED/التحكم بارتفاع الأنوار الأمامية/مكيف أوتوماتيك/وضعيات للقيادة/أوامر صوتية/تحكم مقاعد يدوى/تشغيل عن بعد/مسند ذراع خلفي/أبل كار بلاى/أندرويد أوتو/كشافات ضباب امامية/مصابيح ليد",
    },
    g4_data_layer: {
      post_id: 137267,
      name: "Chery Arrizo 6 Pro Comfort 2023 Standard",
      post_price: 55200,
      post_make: "Chery",
      post_installment_from: "5520",
      post_installment_to: "13800",
      post_model: "Arrizo 6 Pro",
      post_year: "2023",
      post_ext: "Comfort",
      post_origin: "Saudi",
      post_condition: "New",
      post_city: "Al Qurayyat",
      post_exterior_color: "White",
      post_interior_color: "Black",
      post_fuel: "Gasoline",
      post_transmission: "CVT",
      post_cabin: null,
      discount_tag: "Off",
      post_mileage: null,
      post_drivetrain: "FWD",
      post_engine_size: "1.5",
      post_features:
        "مقاعد جلد/فتحات تكييف خلفية/تشغيل بصمة/تحكم دريكسون/مثبت سرعة/زجاج كهربائي/فتح الابواب بالريموت/ ISOFIX لتثبيت مقاعد الاطفال/بلوتوث/مدخل USB/كاميرا خلفية/منافذ طاقة/شاشة وسائط/راديو/وسائد هوائية امامية/فرامل ABS /سنتر لوك/مراقبة ضغط الاطارات/الثبات الإلكتروني ESP/مساعد الفرامل BA/أحزمة أمان/ EBD توزيع قوة الفرامل الكترونيا/نظام التحكم بالإنزلاق (TRC)/فرامل يد الكترونى/مرايا تحكم كهربائي/جنوط/حساسات خلفية/مصابيح هالوجين/اشارات بالمرايا/دخول ذكي/مصابيح ضباب خلفية/أنوار نهارية LED/التحكم بارتفاع الأنوار الأمامية/مكيف أوتوماتيك/وضعيات للقيادة/أوامر صوتية/تحكم مقاعد يدوى/تشغيل عن بعد/مسند ذراع خلفي/أبل كار بلاى/أندرويد أوتو/كشافات ضباب امامية/مصابيح ليد",
      post_cylinder: "4",
      is_finance: "yes",
      inventory_type: 3,
    },
    campaign: null,
    new_tags: [
      {
        tag_name: "جديدة",
        icon: null,
        text_color: "#4B5A6B",
        background_color: "#F1F6FC",
      },
      {
        tag_name: "اقل من السوق بـ ",
        attr: "1,437",
        att_ext: "ريال",
        icon: "https://cdn.syarah.com/syarah/bundles/dddGrn.svg",
        text_color: "#ffffff",
        background_color: "#00b362",
      },
    ],
    limited_quantity: false,
    isFavorite: false,
    can_test_drive: false,
  },
];

export const CarsListFilter = {
  is_new: {
    values: [
      {
        id: null,
        name: "الكل",
      },
      {
        id: 1,
        name: "جديدة",
        name_en: "new",
      },
      {
        id: 0,
        name: "مستعملة",
        name_en: "used",
      },
    ],
    searchable: 0,
    type: "list",
    title: "حالة السيارة",
    field_name: "is_new",
  },
  payment_type: {
    values: [
      {
        id: null,
        name: "الكل",
      },
      {
        id: 1,
        name: "كاش فقط",
        name_en: "Cash Only",
      },
      {
        id: 2,
        name: "كاش و تمويل",
        name_en: "Cash And Finance",
      },
    ],
    searchable: 1,
    type: "list",
    title: "طرق الشراء",
    field_name: "payment_type",
  },
  post_type_payment: {
    values: [
      {
        id: null,
        name: "الكل",
      },
      {
        id: 30,
        name: "Installments",
        name_en: "Installments",
        installment: true,
      },
      {
        id: 20,
        name: "Cash",
        name_en: "Cash",
        installment: false,
      },
      {
        id: 1,
        name: "Waiver",
        name_en: "Waiver",
        installment: false,
      },
    ],
    searchable: 2,
    type: "list",
    title: "طرق الشراء",
    field_name: "post_type_payment",
  },
  makes: {
    values: [
      {
        id: null,
        name: "الكل",
      },
      {
        id: 107,
        name: "forthing",
        name_en: "forthing",
        altName: "forthing",
        disabled: 1,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/107.png",
      },
      {
        id: 4,
        name: "تويوتا",
        name_en: "Toyota",
        altName: "Toyota",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/4.png",
      },
      {
        id: 60,
        name: "هونداي",
        name_en: "Hyundai",
        altName: "Hyundai",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/60.png",
      },
      {
        id: 53,
        name: "مرسيدس",
        name_en: "Mercedes",
        altName: "Mercedes",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/53.png",
      },
      {
        id: 37,
        name: "فورد",
        name_en: "Ford",
        altName: "Ford",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/37.png",
      },
      {
        id: 35,
        name: "شفروليه",
        name_en: "Chevrolet",
        altName: "Chevrolet",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/35.png",
      },
      {
        id: 58,
        name: "نيسان",
        name_en: "Nissan",
        altName: "Nissan",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/58.png",
      },
      {
        id: 38,
        name: "كيا",
        name_en: "Kia",
        altName: "Kia",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/38.png",
      },
      {
        id: 48,
        name: "لكزس",
        name_en: "Lexus",
        altName: "Lexus",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/48.png",
      },
      {
        id: 19,
        name: "GMC",
        name_en: "GMC",
        altName: "GMC",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/19.png",
      },
      {
        id: 5,
        name: "هوندا",
        name_en: "Honda",
        altName: "Honda",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/5.png",
      },
      {
        id: 51,
        name: "مازدا",
        name_en: "Mazda",
        altName: "Mazda",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/51.png",
      },
      {
        id: 55,
        name: "ميتسوبيشي",
        name_en: "Mitsubishi",
        altName: "Mitsubishi",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/55.png",
      },
      {
        id: 15,
        name: "BMW",
        name_en: "BMW",
        altName: "BMW",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/15.png",
      },
      {
        id: 23,
        name: "دودج",
        name_en: "Dodge",
        altName: "Dodge",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/23.png",
      },
      {
        id: 9,
        name: "ايسوزو",
        name_en: "Isuzu",
        altName: "Isuzu",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/9.png",
      },
      {
        id: 69,
        name: "شانجان",
        name_en: "Changan",
        altName: "Changan",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/69.png",
      },
      {
        id: 47,
        name: "لاند روفر",
        name_en: "Range Rover",
        altName: "Range Rover",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/47.png",
      },
      {
        id: 20,
        name: "جيب",
        name_en: "Jeep",
        altName: "Jeep",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/20.png",
      },
      {
        id: 44,
        name: "كرايسلر",
        name_en: "Chrysler",
        altName: "Chrysler",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/44.png",
      },
      {
        id: 78,
        name: "MG",
        name_en: "MG",
        altName: "MG",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/78.png",
      },
      {
        id: 8,
        name: "اودي",
        name_en: "Audi",
        altName: "Audi",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/8.png",
      },
      {
        id: 26,
        name: "رينو",
        name_en: "Renault",
        altName: "Renault",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/26.png",
      },
      {
        id: 43,
        name: "كاديلاك",
        name_en: "Cadillac",
        altName: "Cadillac",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/43.png",
      },
      {
        id: 67,
        name: "جيلي",
        name_en: "Geely",
        altName: "Geely",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/67.png",
      },
      {
        id: 85,
        name: "هافال",
        name_en: "HAVAL",
        altName: "HAVAL",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/85.png",
      },
      {
        id: 33,
        name: "سوزوكي",
        name_en: "Suzuki",
        altName: "Suzuki",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/33.png",
      },
      {
        id: 13,
        name: "بورش",
        name_en: "Porsche",
        altName: "Porsche",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/13.png",
      },
      {
        id: 21,
        name: "دايهاتسو",
        name_en: "Daihatsu",
        altName: "Daihatsu",
        disabled: 2,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/21.png",
      },
      {
        id: 40,
        name: "فولكس فاجن",
        name_en: "Volkswagen",
        altName: "Volkswagen",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/40.png",
      },
      {
        id: 50,
        name: "لينكولن",
        name_en: "Lincoln",
        altName: "Lincoln",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/50.png",
      },
      {
        id: 10,
        name: "انفنتي",
        name_en: "Infiniti",
        altName: "Infiniti",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/10.png",
      },
      {
        id: 18,
        name: "جريت وول",
        name_en: "Great Wall",
        altName: "Great Wall",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/18.png",
      },
      {
        id: 16,
        name: "بيجو",
        name_en: "Peugeot",
        altName: "Peugeot",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/16.png",
      },
      {
        id: 12,
        name: "بنتلي",
        name_en: "Bentley",
        altName: "Bentley",
        disabled: 2,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/12.png",
      },
      {
        id: 17,
        name: "جاغوار",
        name_en: "Jaguar",
        altName: "Jaguar",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/17.png",
      },
      {
        id: 36,
        name: "شيري",
        name_en: "Chery",
        altName: "Chery",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/36.png",
      },
      {
        id: 90,
        name: "GAC",
        name_en: "GAC",
        altName: "GAC",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/90.png",
      },
      {
        id: 59,
        name: "همر",
        name_en: "Hummer",
        altName: "Hummer",
        disabled: 2,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/59.png",
      },
      {
        id: 57,
        name: "ميني",
        name_en: "Mini",
        altName: "Mini",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/57.png",
      },
      {
        id: 66,
        name: "فاو",
        name_en: "FAW",
        altName: "FAW",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/66.png",
      },
      {
        id: 41,
        name: "فيات",
        name_en: "Fiat",
        altName: "Fiat",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/41.png",
      },
      {
        id: 25,
        name: "رولز رویس",
        name_en: "Rolls Royce",
        altName: "Rolls Royce",
        disabled: 2,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/25.png",
      },
      {
        id: 52,
        name: "مازيراتي",
        name_en: "Maserati",
        altName: "Maserati",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/52.png",
      },
      {
        id: 82,
        name: "JAC",
        name_en: "JAC",
        altName: "JAC",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/82.png",
      },
      {
        id: 74,
        name: "BYD",
        name_en: "BYD",
        altName: "BYD",
        disabled: 2,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/74.png",
      },
      {
        id: 95,
        name: "جيتور",
        name_en: "Jetour",
        altName: "Jetour",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/95.png",
      },
      {
        id: 29,
        name: "سانج يونج",
        name_en: "SsangYong",
        altName: "SsangYong",
        disabled: 1,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/29.png",
      },
      {
        id: 99,
        name: "ساوايست",
        name_en: "Soueast",
        altName: "Soueast",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/99.png",
      },
      {
        id: 98,
        name: "جينيسيس",
        name_en: "Genesis",
        altName: "Genesis",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/98.png",
      },
      {
        id: 71,
        name: "JMC",
        name_en: "JMC",
        altName: "JMC",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/71.png",
      },
      {
        id: 46,
        name: "لامبورغيني",
        name_en: "Lamborghini",
        altName: "Lamborghini",
        disabled: 2,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/46.png",
      },
      {
        id: 79,
        name: "فوتون",
        name_en: "FOTON",
        altName: "FOTON",
        disabled: 2,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/79.png",
      },
      {
        id: 77,
        name: "تاتا",
        name_en: "TATA",
        altName: "TATA",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/77.png",
      },
      {
        id: 75,
        name: "بايك",
        name_en: "BAIC",
        altName: "BAIC",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/75.png",
      },
      {
        id: 86,
        name: "CMC",
        name_en: "CMC",
        altName: "CMC",
        disabled: 2,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/86.png",
      },
      {
        id: 81,
        name: "زد أكس أوتو",
        name_en: "ZX Auto",
        altName: "ZX Auto",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/81.png",
      },
      {
        id: 72,
        name: "ماكلارين",
        name_en: "Mclaren",
        altName: "Mclaren",
        disabled: 1,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/72.png",
      },
      {
        id: 92,
        name: "ماكسيس",
        name_en: "Maxus",
        altName: "Maxus",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/92.png",
      },
      {
        id: 96,
        name: "اشوك",
        name_en: "Ashok",
        altName: "Ashok",
        disabled: 2,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/96.png",
      },
      {
        id: 97,
        name: "ماهيندرا",
        name_en: "Mahindra",
        altName: "Mahindra",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/97.png",
      },
      {
        id: 100,
        name: "دونج فينج",
        name_en: "DONG FENG",
        altName: "DONG FENG",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/100.png",
      },
      {
        id: 103,
        name: "هونشي",
        name_en: "Hongqi",
        altName: "Hongqi",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/103.png",
      },
      {
        id: 105,
        name: "اكسيد",
        name_en: "Exceed",
        altName: "Exceed",
        disabled: 0,
        logo: "https://cdn.syarah.com/syarah/bundles/carLogos/105.png",
      },
    ],
    searchable: 0,
    type: "list",
    title: "الماركة",
    field_name: "make_id",
  },
  years: {
    values: [
      {
        id: 0,
        name: "1990",
      },
      {
        id: 1,
        name: "2025",
      },
    ],
    searchable: 0,
    type: "view",
    title: "سنة الصنع",
    field_name: "year",
  },
  price: {
    values: [
      {
        id: 0,
        name: "0",
      },
      {
        id: 1,
        name: "1410000",
      },
    ],
    searchable: 0,
    type: "view",
    title: "السعر",
    field_name: "price",
  },
  milage_range: {
    values: [
      {
        id: 1,
        name: "من صفر الى 50 الف كم",
        name_en: "From 0 to 50K KM",
      },
      {
        id: 2,
        name: "من 50 الف كم الى 70 الف كم",
        name_en: "From 50K KM to 70K KM",
      },
      {
        id: 3,
        name: "من 70 الف كم الى 100 الف كم",
        name_en: "From 70K KM to 100K KM",
      },
      {
        id: 4,
        name: "من 100 الف كم الى 130 الف كم",
        name_en: "From 100K KM to 130K KM",
      },
      {
        id: 5,
        name: "من 130 الف كم الى 185 الف كم",
        name_en: "From 130K KM to 185K KM",
      },
      {
        id: 6,
        name: "اكثر من 185 الف كم",
        name_en: "More than 185K KM",
      },
    ],
    searchable: 0,
    type: "view",
    title: "الممشى",
    field_name: "milage_range",
  },
  options_list: {
    values: [
      {
        id: 5,
        category: "اهم الميزات",
        data: [
          {
            id: 73,
            name: "تشغيل عن بعد",
            name_en: "Remote car starter",
            status: 1,
          },
          {
            id: 62,
            name: "تبريد / تدفئة المقاعد",
            name_en: "seat heating / cooling",
            status: 1,
          },
          {
            id: 6,
            name: "مثبت سرعة",
            name_en: "Cruise Control",
            status: 1,
          },
          {
            id: 45,
            name: "نظام ملاحة / خرائط",
            name_en: "Navigation System",
            status: 1,
          },
          {
            id: 15,
            name: "كاميرا خلفية",
            name_en: "Rear Camera",
            status: 1,
          },
          {
            id: 9,
            name: "بلوتوث",
            name_en: "Bluetooth",
            status: 1,
          },
          {
            id: 83,
            name: "مساعد الاصطفاف",
            name_en: "Auto Parking",
            status: 1,
          },
          {
            id: 50,
            name: "تنبيه النقاط العمياء",
            name_en: "Blind Spot Information",
            status: 1,
          },
          {
            id: 66,
            name: "نظام الزحف",
            name_en: "Crawl Control",
            status: 1,
          },
          {
            id: 23,
            name: "فتحة سقف",
            name_en: "Sunroof",
            status: 1,
          },
          {
            id: 80,
            name: "فتح الشنطة كهربائى",
            name_en: "Open Trunk Electricity",
            status: 1,
          },
          {
            id: 20,
            name: "جنوط",
            name_en: "Rim Wheels",
            status: 1,
          },
        ],
      },
      {
        id: 1,
        category: "الراحة",
        data: [
          {
            id: 73,
            name: "تشغيل عن بعد",
            name_en: "Remote car starter",
            status: 1,
          },
          {
            id: 62,
            name: "تبريد / تدفئة المقاعد",
            name_en: "seat heating / cooling",
            status: 1,
          },
          {
            id: 87,
            name: "تبريد المقاعد",
            name_en: "Seats Cooling",
            status: 1,
          },
          {
            id: 89,
            name: "تدفئة المقاعد",
            name_en: "Seats Heating",
            status: 1,
          },
          {
            id: 58,
            name: "وضعيات للقيادة",
            name_en: "Drive Mode",
            status: 1,
          },
          {
            id: 4,
            name: "تشغيل بصمة",
            name_en: "Fingerprint Ignition",
            status: 1,
          },
          {
            id: 44,
            name: "ثلاجة",
            name_en: "Refrigerator",
            status: 1,
          },
          {
            id: 74,
            name: "قير الكترونى",
            name_en: "Electronic Transmission",
            status: 1,
          },
          {
            id: 6,
            name: "مثبت سرعة",
            name_en: "Cruise Control",
            status: 1,
          },
          {
            id: 77,
            name: "Echo توفير الوقود ايكو",
            name_en: "Echo",
            status: 1,
          },
          {
            id: 3,
            name: "فتحات تكييف خلفية",
            name_en: " Rear AC Vents",
            status: 1,
          },
          {
            id: 33,
            name: "مكيف أوتوماتيك",
            name_en: "A/C Auto",
            status: 1,
          },
          {
            id: 154,
            name: "تحكم مكيف خلفي",
            name_en: "Back Side A/C Control ",
            status: 1,
          },
          {
            id: 63,
            name: "تحكم مقاعد كهرباء",
            name_en: "Power seats",
            status: 1,
          },
          {
            id: 72,
            name: "تحكم مقاعد يدوى",
            name_en: "Manual seats\t",
            status: 1,
          },
          {
            id: 17,
            name: "زجاج امامي كهربائي وخلفي يدوي",
            name_en: "Front Electric & back Manual Windows",
            status: 1,
          },
          {
            id: 16,
            name: "زجاج كهربائي",
            name_en: "Front & Rear Power Windows",
            status: 1,
          },
          {
            id: 29,
            name: "زجاج يدوي",
            name_en: "Manual Windows",
            status: 1,
          },
          {
            id: 2,
            name: "مقاعد جلد",
            name_en: "Leather Seats",
            status: 1,
          },
          {
            id: 133,
            name: "مقاعد قماش وجلد",
            name_en: "Leather & fabric seats",
            status: 1,
          },
          {
            id: 1,
            name: "مقاعد مخمل",
            name_en: "Velvet Seats",
            status: 1,
          },
          {
            id: 25,
            name: "مقاعد قماش",
            name_en: "Fabric Seats",
            status: 1,
          },
          {
            id: 115,
            name: "مقاعد خلفية قابلة للطي",
            name_en: " Foldable rear seats",
            status: 1,
          },
          {
            id: 48,
            name: "فتح الابواب بالريموت",
            name_en: "Remote Entry",
            status: 1,
          },
          {
            id: 26,
            name: "تشغيل مفتاح",
            name_en: "Car Key",
            status: 1,
          },
          {
            id: 5,
            name: "تحكم دريكسون",
            name_en: "Steering Wheel Controls",
            status: 1,
          },
          {
            id: 32,
            name: "مكيف يدوي",
            name_en: "A/C Manual",
            status: 1,
          },
          {
            id: 53,
            name: "تحكم ماوس",
            name_en: "Mouse controller",
            status: 1,
          },
          {
            id: 61,
            name: "ذاكرة المقاعد",
            name_en: "Memory Seats",
            status: 1,
          },
          {
            id: 67,
            name: "أوامر صوتية",
            name_en: "Voice control",
            status: 1,
          },
          {
            id: 70,
            name: "مرايا داخلية ذاتية التعتيم ",
            name_en: "Mirrors (Black)",
            status: 1,
          },
          {
            id: 85,
            name: "مقاعد شامواه",
            name_en: "Chamois seats",
            status: 1,
          },
          {
            id: 95,
            name: "مساج",
            name_en: "Massage",
            status: 1,
          },
          {
            id: 111,
            name: "مكيف لمس",
            name_en: "A/C Touch",
            status: 1,
          },
          {
            id: 113,
            name: " ISOFIX لتثبيت مقاعد الاطفال",
            name_en: "ISOFIX",
            status: 1,
          },
          {
            id: 143,
            name: "مسند ذراع خلفي",
            name_en: "Rear Central Arm Rest",
            status: 1,
          },
          {
            id: 152,
            name: "شيفتات سرعه",
            name_en: "Paddle shift",
            status: 1,
          },
          {
            id: 156,
            name: "ستاير كهربائية",
            name_en: "Electric car curtain",
            status: 1,
          },
        ],
      },
      {
        id: 2,
        category: "تقنيات",
        data: [
          {
            id: 54,
            name: "كاميرا 360",
            name_en: "Camera 360",
            status: 1,
          },
          {
            id: 45,
            name: "نظام ملاحة / خرائط",
            name_en: "Navigation System",
            status: 1,
          },
          {
            id: 82,
            name: "بروجيكتور",
            name_en: "Projector",
            status: 1,
          },
          {
            id: 107,
            name: "أبل كار بلاى",
            name_en: "Apple Car Play",
            status: 1,
          },
          {
            id: 109,
            name: "أندرويد أوتو",
            name_en: "Android Auto",
            status: 1,
          },
          {
            id: 15,
            name: "كاميرا خلفية",
            name_en: "Rear Camera",
            status: 1,
          },
          {
            id: 49,
            name: "شاشة DVD خلفية",
            name_en: "Rear DVD",
            status: 1,
          },
          {
            id: 145,
            name: "عرض شاشة الجوال على الشاشة",
            name_en: "Phone Mirroring",
            status: 1,
          },
          {
            id: 91,
            name: "شاشة وسائط",
            name_en: "Media screen",
            status: 1,
          },
          {
            id: 9,
            name: "بلوتوث",
            name_en: "Bluetooth",
            status: 1,
          },
          {
            id: 10,
            name: "مشغل اسطوانات CD",
            name_en: "CD player",
            status: 1,
          },
          {
            id: 11,
            name: "مدخل USB",
            name_en: "USB Input",
            status: 1,
          },
          {
            id: 31,
            name: "مدخل AUX",
            name_en: "AUX",
            status: 1,
          },
          {
            id: 46,
            name: "شاحن لاسلكي",
            name_en: "Wireless Charging",
            status: 1,
          },
          {
            id: 47,
            name: "منافذ طاقة",
            name_en: "Power connection",
            status: 1,
          },
          {
            id: 83,
            name: "مساعد الاصطفاف",
            name_en: "Auto Parking",
            status: 1,
          },
          {
            id: 97,
            name: "راديو",
            name_en: "Radio",
            status: 1,
          },
          {
            id: 139,
            name: "كاميرا جانبية",
            name_en: "Side camera",
            status: 1,
          },
        ],
      },
      {
        id: 3,
        category: "الامان",
        data: [
          {
            id: 12,
            name: "وسائد هوائية امامية",
            name_en: "Dual Airbag (Driver & Passenger)",
            status: 1,
          },
          {
            id: 13,
            name: "وسائد هوائية جانبية",
            name_en: "Side Airbags",
            status: 1,
          },
          {
            id: 14,
            name: "فرامل ABS ",
            name_en: "ABS",
            status: 1,
          },
          {
            id: 34,
            name: "سنتر لوك",
            name_en: "Center Lock",
            status: 1,
          },
          {
            id: 38,
            name: "المساعدة على صعود المرتفعات HAC",
            name_en: "Hill start Assist Control",
            status: 1,
          },
          {
            id: 40,
            name: "أحزمة أمان",
            name_en: "Safety belts",
            status: 1,
          },
          {
            id: 50,
            name: "تنبيه النقاط العمياء",
            name_en: "Blind Spot Information",
            status: 1,
          },
          {
            id: 52,
            name: "تنبيه مغادرة المسار",
            name_en: "Lane Departure Warning System",
            status: 1,
          },
          {
            id: 55,
            name: "رادار",
            name_en: "Radar",
            status: 1,
          },
          {
            id: 56,
            name: "نظام المساعدة على نزول المنحدرات HDC",
            name_en: "Hill Descent Control",
            status: 1,
          },
          {
            id: 57,
            name: "نظام التحكم بالإنزلاق (TRC)",
            name_en: "Traction Control System",
            status: 1,
          },
          {
            id: 64,
            name: "دفلوك",
            name_en: "Diff Lock",
            status: 1,
          },
          {
            id: 66,
            name: "نظام الزحف",
            name_en: "Crawl Control",
            status: 1,
          },
          {
            id: 68,
            name: "تحكم فى الحساسات",
            name_en: "Sensors control",
            status: 1,
          },
          {
            id: 69,
            name: "تنبيه الاصطدام الأمامي",
            name_en: "Forward Collision Warning",
            status: 1,
          },
          {
            id: 78,
            name: "فرامل تلقائى للطوارىء",
            name_en: "Automatic Emergency Brake",
            status: 1,
          },
          {
            id: 35,
            name: "مراقبة ضغط الاطارات",
            name_en: "Tire Pressure Monitoring System",
            status: 1,
          },
          {
            id: 36,
            name: "الثبات الإلكتروني ESP",
            name_en: "Electronic Stability Program",
            status: 1,
          },
          {
            id: 37,
            name: "مساعد الفرامل BA",
            name_en: "Brake Assist System",
            status: 1,
          },
          {
            id: 51,
            name: " EBD توزيع قوة الفرامل الكترونيا",
            name_en: "Electronic Brakeforce Distribution",
            status: 1,
          },
          {
            id: 71,
            name: "فرامل يد الكترونى",
            name_en: "Auto Hold",
            status: 1,
          },
          {
            id: 125,
            name: "قفل الباب التلقائى",
            name_en: "Auto Lock System",
            status: 1,
          },
          {
            id: 127,
            name: "فتح الباب التلقائى فى حالة الصدام",
            name_en: "Collision Un-locker",
            status: 1,
          },
        ],
      },
      {
        id: 4,
        category: "تجهيزات خارجية",
        data: [
          {
            id: 24,
            name: "فتحة سقف بانوراما",
            name_en: "Panorama Sunroof",
            status: 1,
          },
          {
            id: 23,
            name: "فتحة سقف",
            name_en: "Sunroof",
            status: 1,
          },
          {
            id: 93,
            name: "دخول ذكي",
            name_en: "Keyless Entry System",
            status: 1,
          },
          {
            id: 80,
            name: "فتح الشنطة كهربائى",
            name_en: "Open Trunk Electricity",
            status: 1,
          },
          {
            id: 22,
            name: "حساسات خلفية",
            name_en: "Rear Parking Sensors",
            status: 1,
          },
          {
            id: 18,
            name: "مرايا تحكم كهربائي",
            name_en: "Electrical Mirrors",
            status: 1,
          },
          {
            id: 117,
            name: "أنوار نهارية LED",
            name_en: "Daytime Running Lights",
            status: 1,
          },
          {
            id: 81,
            name: "مصابيح زينون",
            name_en: "Xenon lamps",
            status: 1,
          },
          {
            id: 28,
            name: "مصابيح ليد",
            name_en: "LED Lamps",
            status: 1,
          },
          {
            id: 27,
            name: "مصابيح هالوجين",
            name_en: "Halogen Lamps",
            status: 1,
          },
          {
            id: 20,
            name: "جنوط",
            name_en: "Rim Wheels",
            status: 1,
          },
          {
            id: 21,
            name: "طيس",
            name_en: "Cover Wheels",
            status: 1,
          },
          {
            id: 19,
            name: "كشافات ضباب امامية",
            name_en: "Front Fog Lamps",
            status: 1,
          },
          {
            id: 41,
            name: "مزيل ضباب",
            name_en: "Window Defroster",
            status: 1,
          },
          {
            id: 42,
            name: "حساسات أمامية",
            name_en: "Front sensors",
            status: 1,
          },
          {
            id: 43,
            name: "اشارات بالمرايا",
            name_en: "Side Turn Signals",
            status: 1,
          },
          {
            id: 59,
            name: "هوك خلفى",
            name_en: "Hawk Rear",
            status: 1,
          },
          {
            id: 60,
            name: "ونش أمامى",
            name_en: "Front winch",
            status: 1,
          },
          {
            id: 65,
            name: "جناح خلفى",
            name_en: "Rear spoiler",
            status: 1,
          },
          {
            id: 75,
            name: "تحكم يدوى بالمرايات",
            name_en: "Manual Mirrors\t",
            status: 1,
          },
          {
            id: 76,
            name: "غمازات إشارة علي الرفرف",
            name_en: "Flasher",
            status: 1,
          },
          {
            id: 79,
            name: " ماسحات استشعار المطر",
            name_en: "Rain Sensing Wipers",
            status: 1,
          },
          {
            id: 105,
            name: "مصابيح ضباب خلفية",
            name_en: "Rear Fog Lights",
            status: 1,
          },
          {
            id: 119,
            name: "غسيل المصابيح الأمامية",
            name_en: "Headlamp washers",
            status: 1,
          },
          {
            id: 121,
            name: "عتبات جانبية",
            name_en: "Side sills",
            status: 1,
          },
          {
            id: 123,
            name: "حنايا عفش",
            name_en: "Cargo Carrier",
            status: 1,
          },
          {
            id: 129,
            name: "التحكم بارتفاع الأنوار الأمامية",
            name_en: "Headlight Electronic Adjustment",
            status: 1,
          },
          {
            id: 141,
            name: "تسخين مرايا خارجية",
            name_en: "Heated Outside Mirrors",
            status: 1,
          },
          {
            id: 151,
            name: "مرايا قابلة للطي كهربائيا",
            name_en: "Electrical Fold Outside Mirror",
            status: 1,
          },
          {
            id: 158,
            name: "أرقام سرية على الباب",
            name_en: "Secret numbers on door",
            status: 1,
          },
        ],
      },
    ],
    searchable: 0,
    type: "GroupList",
    title: "الميزات",
    field_name: "options_list",
  },
  colors: {
    values: [
      {
        id: 1,
        name: "أبيض",
        name_en: "White",
        color: "#FFFFFF",
      },
      {
        id: 2,
        name: "أسود",
        name_en: "Black",
        color: "#000000",
      },
      {
        id: 3,
        name: "سلفر",
        name_en: "Silver",
        color: "#E3E3E3",
      },
      {
        id: 4,
        name: "أحمر",
        name_en: "Red",
        color: "#DA3434",
      },
      {
        id: 5,
        name: "بني",
        name_en: "Brown",
        color: "#873F0B",
      },
      {
        id: 6,
        name: "ازرق",
        name_en: "Blue",
        color: "#0056C1",
      },
      {
        id: 7,
        name: "أخضر",
        name_en: "Green",
        color: "#2AA313",
      },
      {
        id: 8,
        name: "أصفر",
        name_en: "Yellow",
        color: "#FFE800",
      },
      {
        id: 10,
        name: "رمادي",
        name_en: "Grey ",
        color: "#BDBDBD",
      },
      {
        id: 11,
        name: "أزرق غامق ( كحلي )",
        name_en: "Dark Blue",
        color: "#0E197E",
      },
      {
        id: 12,
        name: "زيتي",
        name_en: "Oil Green",
        color: "#1A6A0B",
      },
      {
        id: 13,
        name: "برتقالي",
        name_en: "Orange",
        color: "#ED4E00",
      },
      {
        id: 14,
        name: "ذهبي",
        name_en: "Golden",
        color: "#FFC700",
      },
      {
        id: 15,
        name: "برونزي",
        name_en: "Bronze",
        color: "#E0C8A1",
      },
      {
        id: 16,
        name: "بيج",
        name_en: "Beige",
        color: "#F8ECD1",
      },
      {
        id: 17,
        name: "جملي",
        name_en: "Camel ",
        color: "#dbbfa2",
      },
      {
        id: 18,
        name: "أسمنتي",
        name_en: "Nardo Gray",
        color: "#686A6C",
      },
      {
        id: 19,
        name: "بني غامق",
        name_en: "Dark Brown ",
        color: "#4E3524",
      },
      {
        id: 20,
        name: "أرزق فاتح",
        name_en: "Baby blue",
        color: "#89CFF0",
      },
      {
        id: 21,
        name: "عنابي ( نبيتي )",
        name_en: "Burgundy",
        color: "#800020",
      },
      {
        id: 22,
        name: "بترولي",
        name_en: "Petrol",
        color: "#005f6a",
      },
      {
        id: 23,
        name: "رمادي فاتح",
        name_en: "Light gray",
        color: "#D3D3D3",
      },
      {
        id: 24,
        name: "بنفسجي",
        name_en: "Purple",
        color: "#A020F0",
      },
      {
        id: 25,
        name: "ليموني",
        name_en: "Limon",
        color: "#e3ff00",
      },
      {
        id: 26,
        name: "رصاصي",
        name_en: "leaden",
        color: "#d3d3d3",
      },
      {
        id: 27,
        name: "رصاصي غامق",
        name_en: "Dark leaden",
        color: "#A9A9A9",
      },
      {
        id: 28,
        name: "ذهبي فاتح",
        name_en: "light golden",
        color: "#F1E5AC",
      },
      {
        id: 29,
        name: "أحمر غامق",
        name_en: "Burgundy",
        color: "#68403e",
      },
      {
        id: 31,
        name: "ذهبي غامق",
        name_en: "Dark Golden",
        color: "#AA6C39",
      },
      {
        id: 9,
        name: "لون آخر",
        color: "",
        name_en: "another_color",
      },
    ],
    searchable: 0,
    type: "grid",
    title: "اللون الخارجي",
    field_name: "color",
  },
  interior_colors: {
    values: [
      {
        id: 1,
        name: "أبيض",
        name_en: "White",
        color: "#FFFFFF",
      },
      {
        id: 2,
        name: "أسود",
        name_en: "Black",
        color: "#000000",
      },
      {
        id: 3,
        name: "سلفر",
        name_en: "Silver",
        color: "#E3E3E3",
      },
      {
        id: 4,
        name: "أحمر",
        name_en: "Red",
        color: "#DA3434",
      },
      {
        id: 5,
        name: "بني",
        name_en: "Brown",
        color: "#873F0B",
      },
      {
        id: 6,
        name: "ازرق",
        name_en: "Blue",
        color: "#0056C1",
      },
      {
        id: 7,
        name: "أخضر",
        name_en: "Green",
        color: "#2AA313",
      },
      {
        id: 8,
        name: "أصفر",
        name_en: "Yellow",
        color: "#FFE800",
      },
      {
        id: 10,
        name: "رمادي",
        name_en: "Grey ",
        color: "#BDBDBD",
      },
      {
        id: 11,
        name: "أزرق غامق ( كحلي )",
        name_en: "Dark Blue",
        color: "#0E197E",
      },
      {
        id: 12,
        name: "زيتي",
        name_en: "Oil Green",
        color: "#1A6A0B",
      },
      {
        id: 13,
        name: "برتقالي",
        name_en: "Orange",
        color: "#ED4E00",
      },
      {
        id: 14,
        name: "ذهبي",
        name_en: "Golden",
        color: "#FFC700",
      },
      {
        id: 15,
        name: "برونزي",
        name_en: "Bronze",
        color: "#E0C8A1",
      },
      {
        id: 16,
        name: "بيج",
        name_en: "Beige",
        color: "#F8ECD1",
      },
      {
        id: 17,
        name: "جملي",
        name_en: "Camel ",
        color: "#dbbfa2",
      },
      {
        id: 18,
        name: "أسمنتي",
        name_en: "Nardo Gray",
        color: "#686A6C",
      },
      {
        id: 19,
        name: "بني غامق",
        name_en: "Dark Brown ",
        color: "#4E3524",
      },
      {
        id: 20,
        name: "أرزق فاتح",
        name_en: "Baby blue",
        color: "#89CFF0",
      },
      {
        id: 21,
        name: "عنابي ( نبيتي )",
        name_en: "Burgundy",
        color: "#800020",
      },
      {
        id: 22,
        name: "بترولي",
        name_en: "Petrol",
        color: "#005f6a",
      },
      {
        id: 23,
        name: "رمادي فاتح",
        name_en: "Light gray",
        color: "#D3D3D3",
      },
      {
        id: 24,
        name: "بنفسجي",
        name_en: "Purple",
        color: "#A020F0",
      },
      {
        id: 25,
        name: "ليموني",
        name_en: "Limon",
        color: "#e3ff00",
      },
      {
        id: 26,
        name: "رصاصي",
        name_en: "leaden",
        color: "#d3d3d3",
      },
      {
        id: 27,
        name: "رصاصي غامق",
        name_en: "Dark leaden",
        color: "#A9A9A9",
      },
      {
        id: 28,
        name: "ذهبي فاتح",
        name_en: "light golden",
        color: "#F1E5AC",
      },
      {
        id: 29,
        name: "أحمر غامق",
        name_en: "Burgundy",
        color: "#68403e",
      },
      {
        id: 31,
        name: "ذهبي غامق",
        name_en: "Dark Golden",
        color: "#AA6C39",
      },
      {
        id: 9,
        name: "لون آخر",
        color: "",
        name_en: "another_color",
      },
    ],
    searchable: 0,
    type: "grid",
    title: "اللون الداخلي",
    field_name: "interior_color",
  },
  car_origin: {
    values: [
      {
        id: null,
        name: "الكل",
      },
      {
        id: 1,
        name: "سعودي",
        name_en: "Saudi",
      },
      {
        id: 2,
        name: "خليجي",
        name_en: "GCC",
      },
      {
        id: 3,
        name: "اخرى",
        name_en: "Other",
      },
    ],
    searchable: 0,
    type: "list",
    title: "الوارد",
    field_name: "car_origin",
  },
  car_shapes: {
    values: [
      {
        id: 2,
        name: "سيدان",
        name_en: "Sedan",
        logo: "https://cdn.syarah.com/syarah/bundles/sedan.svg",
      },
      {
        id: 3,
        name: "بيك أب",
        name_en: "Pickup",
        logo: "https://cdn.syarah.com/syarah/bundles/pickup.svg",
      },
      {
        id: 4,
        name: "أس يو في",
        name_en: "SUV",
        logo: "https://cdn.syarah.com/syarah/bundles/suv.svg",
      },
      {
        id: 5,
        name: "كروس اوفر",
        name_en: "Crossovers",
        logo: "https://cdn.syarah.com/syarah/bundles/cross.svg",
      },
      {
        id: 6,
        name: "رياضية",
        name_en: "Sport",
        logo: "https://cdn.syarah.com/syarah/bundles/sport.svg",
      },
      {
        id: 7,
        name: "هاتشباك",
        name_en: "Hatchback",
        logo: "https://cdn.syarah.com/syarah/bundles/hatch.svg",
      },
      {
        id: 8,
        name: "فان",
        name_en: "Van",
        logo: "https://cdn.syarah.com/syarah/bundles/van.svg",
      },
    ],
    searchable: 0,
    type: "grid",
    title: "الشكل",
    field_name: "car_shape",
  },
  engine_size: {
    values: [
      {
        id: null,
        name: "الكل",
      },
      {
        id: 1,
        name: "1.0",
      },
      {
        id: 2,
        name: "1.1",
      },
      {
        id: 3,
        name: "1.2",
      },
      {
        id: 4,
        name: "1.3",
      },
      {
        id: 5,
        name: "1.4",
      },
      {
        id: 6,
        name: "1.5",
      },
      {
        id: 7,
        name: "1.6",
      },
      {
        id: 8,
        name: "1.7",
      },
      {
        id: 9,
        name: "1.8",
      },
      {
        id: 10,
        name: "1.9",
      },
      {
        id: 11,
        name: "2.0",
      },
      {
        id: 12,
        name: "2.1",
      },
      {
        id: 13,
        name: "2.2",
      },
      {
        id: 14,
        name: "2.3",
      },
      {
        id: 15,
        name: "2.4",
      },
      {
        id: 16,
        name: "2.5",
      },
      {
        id: 17,
        name: "2.6",
      },
      {
        id: 18,
        name: "2.7",
      },
      {
        id: 19,
        name: "2.8",
      },
      {
        id: 20,
        name: "2.9",
      },
      {
        id: 21,
        name: "3.0",
      },
      {
        id: 22,
        name: "3.1",
      },
      {
        id: 23,
        name: "3.2",
      },
      {
        id: 24,
        name: "3.3",
      },
      {
        id: 25,
        name: "3.4",
      },
      {
        id: 26,
        name: "3.5",
      },
      {
        id: 27,
        name: "3.6",
      },
      {
        id: 28,
        name: "3.7",
      },
      {
        id: 29,
        name: "3.8",
      },
      {
        id: 30,
        name: "3.9",
      },
      {
        id: 31,
        name: "4.0",
      },
      {
        id: 32,
        name: "4.1",
      },
      {
        id: 33,
        name: "4.2",
      },
      {
        id: 34,
        name: "4.3",
      },
      {
        id: 35,
        name: "4.4",
      },
      {
        id: 36,
        name: "4.5",
      },
      {
        id: 37,
        name: "4.6",
      },
      {
        id: 38,
        name: "4.7",
      },
      {
        id: 39,
        name: "4.8",
      },
      {
        id: 40,
        name: "4.9",
      },
      {
        id: 41,
        name: "5.0",
      },
      {
        id: 42,
        name: "5.1",
      },
      {
        id: 43,
        name: "5.2",
      },
      {
        id: 44,
        name: "5.3",
      },
      {
        id: 45,
        name: "5.4",
      },
      {
        id: 46,
        name: "5.5",
      },
      {
        id: 47,
        name: "5.6",
      },
      {
        id: 48,
        name: "5.7",
      },
      {
        id: 49,
        name: "5.8",
      },
      {
        id: 50,
        name: "5.9",
      },
      {
        id: 51,
        name: "6.0",
      },
      {
        id: 52,
        name: "6.1",
      },
      {
        id: 53,
        name: "6.2",
      },
      {
        id: 54,
        name: "6.3",
      },
      {
        id: 55,
        name: "6.4",
      },
      {
        id: 56,
        name: "6.5",
      },
      {
        id: 57,
        name: "6.6",
      },
      {
        id: 58,
        name: "6.7",
      },
      {
        id: 59,
        name: "6.8",
      },
      {
        id: 60,
        name: "6.9",
      },
      {
        id: 61,
        name: "7.0",
      },
      {
        id: 62,
        name: "7.1",
      },
      {
        id: 63,
        name: "7.2",
      },
      {
        id: 64,
        name: "7.3",
      },
      {
        id: 65,
        name: "7.4",
      },
      {
        id: 66,
        name: "7.5",
      },
      {
        id: 67,
        name: "7.6",
      },
      {
        id: 68,
        name: "7.7",
      },
      {
        id: 69,
        name: "7.8",
      },
      {
        id: 70,
        name: "7.9",
      },
      {
        id: 71,
        name: "8.0",
      },
      {
        id: 72,
        name: "8.1",
      },
      {
        id: 73,
        name: "8.2",
      },
      {
        id: 74,
        name: "8.3",
      },
      {
        id: 75,
        name: "8.4",
      },
      {
        id: 76,
        name: "8.5",
      },
      {
        id: 77,
        name: "8.6",
      },
      {
        id: 78,
        name: "8.7",
      },
      {
        id: 79,
        name: "8.8",
      },
      {
        id: 80,
        name: "8.9",
      },
      {
        id: 81,
        name: "9.0",
      },
    ],
    searchable: 0,
    type: "list",
    title: "سعة المحرك",
    field_name: "engine_size",
  },
  fuel_types: {
    values: [
      {
        id: null,
        name: "الكل",
      },
      {
        id: 1,
        name: "بنزين",
        name_en: "Gasoline",
      },
      {
        id: 2,
        name: "ديزل",
        name_en: "Diesel",
      },
      {
        id: 3,
        name: "هايبرد/هجين",
        name_en: "Hybrid",
      },
      {
        id: 4,
        name: "كهرباء",
        name_en: "Electric",
      },
    ],
    searchable: 0,
    type: "checkbox",
    title: "نوع الوقود",
    field_name: "fuel_type",
  },
  transmission_type: {
    values: [
      {
        id: null,
        name: "الكل",
      },
      {
        id: 1,
        name: "عادي",
        name_en: "Manual",
      },
      {
        id: 2,
        name: "اوتوماتيك",
        name_en: "Automatic",
      },
      {
        id: 3,
        name: "CVT",
        name_en: "CVT",
      },
    ],
    searchable: 0,
    type: "list",
    title: "الجير",
    field_name: "transmission_type",
  },
  milage: {
    values: [],
    searchable: 0,
    type: "view",
    title: "الممشى",
    field_name: "milage",
  },
  cities: {
    values: [
      {
        id: null,
        name: "الكل",
      },
      {
        id: 64,
        name: "الرس",
        name_en: "Alras",
        altName: "Alras",
      },
      {
        id: 76,
        name: "خميس مشيط",
        name_en: "khamis Mushait",
        altName: "khamis Mushait",
      },
      {
        id: 1,
        name: "الرياض",
        name_en: "Riyadh",
        altName: "Riyadh",
      },
      {
        id: 12,
        name: "جدة",
        name_en: "Jeddah",
        altName: "Jeddah",
      },
      {
        id: 4,
        name: "الاحساء",
        name_en: "Ihsaa",
        altName: "Ihsaa",
      },
      {
        id: 5,
        name: "الباحة",
        name_en: "Baha",
        altName: "Baha",
      },
      {
        id: 6,
        name: "الجوف",
        name_en: "Joof",
        altName: "Joof",
      },
      {
        id: 19,
        name: "الدمام",
        name_en: "Dammam",
        altName: "Dammam",
      },
      {
        id: 7,
        name: "الطائف",
        name_en: "Taef",
        altName: "Taef",
      },
      {
        id: 8,
        name: "القصيم",
        name_en: "Qaseem",
        altName: "Qaseem",
      },
      {
        id: 9,
        name: "المدينة المنورة",
        name_en: "Madinah",
        altName: "Madinah",
      },
      {
        id: 10,
        name: "تبوك",
        name_en: "Tabouk",
        altName: "Tabouk",
      },
      {
        id: 11,
        name: "جازان",
        name_en: "Jazan",
        altName: "Jazan",
      },
      {
        id: 13,
        name: "حائل",
        name_en: "Hael",
        altName: "Hael",
      },
      {
        id: 14,
        name: "عرعر",
        name_en: "ArAr",
        altName: "ArAr",
      },
      {
        id: 16,
        name: "مكة المكرمة",
        name_en: "Mecca",
        altName: "Mecca",
      },
      {
        id: 17,
        name: "نجران",
        name_en: "Najran",
        altName: "Najran",
      },
      {
        id: 29,
        name: "الخبر",
        name_en: "El Khabar",
        altName: "El Khabar",
      },
      {
        id: 30,
        name: "بيشة",
        name_en: "Bisha",
        altName: "Bisha",
      },
      {
        id: 31,
        name: "النماص",
        name_en: "Al Namas",
        altName: "Al Namas",
      },
      {
        id: 32,
        name: "صبيا",
        name_en: "Sabya",
        altName: "Sabya",
      },
      {
        id: 33,
        name: "سكاكا",
        name_en: "Sakaka",
        altName: "Sakaka",
      },
      {
        id: 2,
        name: "أبها",
        name_en: "Abha",
        altName: "Abha",
      },
      {
        id: 21,
        name: "حفر الباطن",
        name_en: "Hafr AlBaten",
        altName: "Hafr AlBaten",
      },
      {
        id: 34,
        name: "القريات",
        name_en: "Al Qurayyat",
        altName: "Al Qurayyat",
      },
      {
        id: 23,
        name: "الجبيل",
        name_en: "Jubail",
        altName: "Jubail",
      },
      {
        id: 24,
        name: "ينبع",
        name_en: "Yanbu",
        altName: "Yanbu",
      },
    ],
    searchable: 2,
    type: "list",
    title: "المدينة",
    field_name: "city_id",
  },
  cities_online: {
    values: [
      {
        id: 64,
        name: "الرس",
        name_en: "Alras",
        altName: "Alras",
      },
      {
        id: 76,
        name: "خميس مشيط",
        name_en: "khamis Mushait",
        altName: "khamis Mushait",
      },
      {
        id: 1,
        name: "الرياض",
        name_en: "Riyadh",
        altName: "Riyadh",
      },
      {
        id: 12,
        name: "جدة",
        name_en: "Jeddah",
        altName: "Jeddah",
      },
      {
        id: 4,
        name: "الاحساء",
        name_en: "Ihsaa",
        altName: "Ihsaa",
      },
      {
        id: 5,
        name: "الباحة",
        name_en: "Baha",
        altName: "Baha",
      },
      {
        id: 19,
        name: "الدمام",
        name_en: "Dammam",
        altName: "Dammam",
      },
      {
        id: 7,
        name: "الطائف",
        name_en: "Taef",
        altName: "Taef",
      },
      {
        id: 8,
        name: "القصيم",
        name_en: "Qaseem",
        altName: "Qaseem",
      },
      {
        id: 9,
        name: "المدينة المنورة",
        name_en: "Madinah",
        altName: "Madinah",
      },
      {
        id: 10,
        name: "تبوك",
        name_en: "Tabouk",
        altName: "Tabouk",
      },
      {
        id: 11,
        name: "جازان",
        name_en: "Jazan",
        altName: "Jazan",
      },
      {
        id: 13,
        name: "حائل",
        name_en: "Hael",
        altName: "Hael",
      },
      {
        id: 14,
        name: "عرعر",
        name_en: "ArAr",
        altName: "ArAr",
      },
      {
        id: 16,
        name: "مكة المكرمة",
        name_en: "Mecca",
        altName: "Mecca",
      },
      {
        id: 17,
        name: "نجران",
        name_en: "Najran",
        altName: "Najran",
      },
      {
        id: 29,
        name: "الخبر",
        name_en: "El Khabar",
        altName: "El Khabar",
      },
      {
        id: 30,
        name: "بيشة",
        name_en: "Bisha",
        altName: "Bisha",
      },
      {
        id: 31,
        name: "النماص",
        name_en: "Al Namas",
        altName: "Al Namas",
      },
      {
        id: 32,
        name: "صبيا",
        name_en: "Sabya",
        altName: "Sabya",
      },
      {
        id: 2,
        name: "أبها",
        name_en: "Abha",
        altName: "Abha",
      },
      {
        id: 33,
        name: "سكاكا",
        name_en: "Sakaka",
        altName: "Sakaka",
      },
      {
        id: 34,
        name: "القريات",
        name_en: "Al Qurayyat",
        altName: "Al Qurayyat",
      },
      {
        id: 21,
        name: "حفر الباطن",
        name_en: "Hafr AlBaten",
        altName: "Hafr AlBaten",
      },
      {
        id: 23,
        name: "الجبيل",
        name_en: "Jubail",
        altName: "Jubail",
      },
      {
        id: 24,
        name: "ينبع",
        name_en: "Yanbu",
        altName: "Yanbu",
      },
    ],
    searchable: 2,
    type: "view",
    title: "المدينة",
    field_name: "city_id",
  },
  post_types: {
    values: [
      {
        id: null,
        name: "الكل",
      },
      {
        id: 2,
        name: "سيارات الأفراد",
        name_en: "Individuals Cars",
      },
      {
        id: 3,
        name: "سيارات المعارض",
        name_en: "Dealers Cars",
      },
    ],
    searchable: 2,
    type: "list",
    title: "نوع البائع",
    field_name: "post_type",
  },
  cylindars: {
    values: [
      {
        id: null,
        name: "الكل",
      },
      {
        id: 3,
        name: "3 سيلندر",
        name_en: "3 cylindars",
      },
      {
        id: 4,
        name: "4 سيلندر",
        name_en: "4 cylindars",
      },
      {
        id: 5,
        name: "5 سيلندر",
        name_en: "5 cylindars",
      },
      {
        id: 6,
        name: "6 سيلندر",
        name_en: "6 cylindars",
      },
      {
        id: 8,
        name: "8 سيلندر",
        name_en: "8 cylindars",
      },
      {
        id: 10,
        name: "10 سيلندر",
        name_en: "10 cylindars",
      },
      {
        id: 12,
        name: "12 سيلندر",
        name_en: "12 cylindars",
      },
    ],
    searchable: 0,
    type: "list",
    title: "عدد السليندرات",
    field_name: "cylindars",
  },
  cabins_numbers: {
    values: [
      {
        id: null,
        name: "الكل",
      },
      {
        id: 1,
        name: "غمارة",
        name_en: "One Cabin",
      },
      {
        id: 2,
        name: "غمارتين",
        name_en: "Two Cabin",
      },
    ],
    searchable: 0,
    type: "list",
    title: "عدد الغمارات",
    field_name: "cabin_numbers",
  },
  monthly_installment: {
    values: [
      {
        id: 0,
        name: "500",
      },
      {
        id: 1,
        name: "100000",
      },
    ],
    searchable: 2,
    type: "view",
    title: "القسط الشهري",
    field_name: "monthly_installment",
  },
  drivetrain_type: {
    values: [
      {
        id: null,
        name: "الكل",
      },
      {
        id: 1,
        name: "دبل  (4x4)",
        name_en: "Double (4x4)",
      },
      {
        id: 2,
        name: "دفع خلفي",
        name_en: "RWD",
      },
      {
        id: 3,
        name: "دفع امامي",
        name_en: "FWD",
      },
      {
        id: 4,
        name: "دفع كلي",
        name_en: "AWD",
      },
    ],
    searchable: 0,
    type: "list",
    title: "نوع الدفع",
    field_name: "drivetrain_type",
  },
};

export const DaysInArabic = [
  "الأحد",
  "الإثنين",
  "الثلاثاء",
  "الأربعاء",
  "الخميس",
  "الجمعة",
  "السبت",
];
